import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
  useMemo,
} from "react";
import { Form, Spinner } from "react-bootstrap";
import axios from "../../utils/axios";
import "./ChatSidebar.css";
import "./ChatBot.css";
import { toast } from "react-toastify";
import { config } from "../../constants";
import Prism from "prismjs";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-sql";
import "prismjs/components/prism-yaml";
import { Clock, Trash2, Check, Play, Plus, ChevronsRight, RefreshCw, Database, FileText, UploadCloud, Smartphone } from "react-feather";
import { QRCodeSVG } from "qrcode.react";
import moment from "moment";
import DatajoltSpinner from "../global/DatajoltSpinner";
import DeleteChatModal from "../Modals/DeleteChat";
import { CircularProgress, Button, Tooltip } from "@mui/material";
import Dropdown from "../global/Dropdown";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import remarkEmoji from "remark-emoji";
import SuggestedQuestions from "./SuggestedQuestions";
import { useAuth, useTenantsState } from "../../auth/workosAuth";
import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  ChartTooltip,
  Legend
);

// Add Snowflake SQL functions to Prism
Prism.languages.sql = {
  ...Prism.languages.sql,
  function: {
    pattern:
      /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MIN|MOD|NOW|ROUND|SUM|UCASE|DATEADD|DATEDIFF|DATE_TRUNC|TIMEADD|TIMEDIFF|TO_TIMESTAMP|TO_DATE|TO_TIME|TO_VARIANT|TO_OBJECT|TO_ARRAY|TO_NUMBER|TO_DECIMAL|TO_DOUBLE|TO_REAL|TO_STRING|TO_BOOLEAN|IFNULL|ISNULL|NVL|NVL2|NULLIF|COALESCE|IFF|ZEROIFNULL|REGEXP_COUNT|REGEXP_INSTR|REGEXP_LIKE|REGEXP_SUBSTR|REGEXP_REPLACE|CONTAINS|ENDSWITH|STARTSWITH|TRIM|LTRIM|RTRIM|UPPER|LOWER|INITCAP|CONCAT|CONCAT_WS|REPLACE|SPLIT|SPLIT_PART|CHARINDEX|LEFT|RIGHT|LEN|SUBSTRING|TRANSLATE|TRY_CAST|TRY_TO_DATE|TRY_TO_DECIMAL|TRY_TO_NUMBER|TRY_TO_TIME|TRY_TO_TIMESTAMP|CURRENT_TIMESTAMP|CURRENT_TIME|CURRENT_DATE|LOCALTIME|LOCALTIMESTAMP|CONVERT_TIMEZONE|EXTRACT|DAYNAME|MONTHNAME|YEAR|MONTH|DAY|HOUR|MINUTE|SECOND|WEEK|QUARTER|ROW_NUMBER|RANK|DENSE_RANK|LAG|LEAD|FIRST_VALUE|LAST_VALUE|GROUPING|LISTAGG|ARRAY_AGG|OBJECT_AGG|ARRAY_APPEND|ARRAY_CAT|ARRAY_COMPACT|ARRAY_CONTAINS|ARRAY_INSERT|ARRAY_INTERSECTION|ARRAY_POSITION|ARRAY_PREPEND|ARRAY_SIZE|ARRAY_SLICE|ARRAY_TO_STRING|CAST|TRY_CAST|PARSE_JSON|GET_PATH|FLATTEN|TYPEOF|OBJECT_KEYS|OBJECT_VALUES|BASE64_ENCODE|BASE64_DECODE|MD5|SHA1|SHA2|UUID_STRING|RANDOM|SEQ1|SEQ2|SEQ4|SEQ8|STRTOK|STRTOK_TO_ARRAY|SPLIT_TO_TABLE|REGEXP_COUNT|REGEXP_INSTR|REGEXP_LIKE|REGEXP_SUBSTR|REGEXP_REPLACE|RLIKE|SOUNDEX|EDITDISTANCE|HASH|HEX_ENCODE|HEX_DECODE|COMPRESS|DECOMPRESS|GET|GET_IGNORE_CASE|XMLGET|COLLATE|COLLATION|EQUAL_NULL|GREATEST|LEAST|UNIFORM|BERNOULLI|NORMAL|EXPONENTIAL|BINOMIAL|GAMMA|POISSON|CHI_SQUARE|BETA|STUDENT_T|WEIBULL|FISHER_F|RAYLEIGH|CAUCHY|LAPLACE|LOGISTIC|PARETO|HNORMAL|HGAMMA|HBETA|HFISHER_F|HSTUDENT_T|HCHI_SQUARE|HWEIBULL|HCAUCHY|HLAPLACE|HLOGISTIC|HPARETO)\b/i,
    alias: "function",
  },
  keyword: {
    pattern:
      /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:_INSERT|COL)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:S|ING)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    alias: "keyword",
  },
  comment: [
    {
      pattern: /\/\/\s*\.\.\.\s*existing\s*code\s*\.\.\.\s*/,
      greedy: true,
      alias: 'existing-code'
    },
    {
      pattern: /--.*$/m,
      greedy: true,
      alias: 'sql-line-comment'
    },
    {
      pattern: /\/\*[\s\S]*?\*\//,
      greedy: true,
      alias: 'sql-block-comment'
    }
  ],
};

Prism.languages.yaml = {
  comment: {
    pattern: /\/\/.*|\/\*[\s\S]*?\*\//,
    greedy: true,
    alias: 'existing-code'
  },
  string: {
    pattern: /"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'/,
    greedy: true
  },
  'key-value': {
    pattern: /(:[ \t]*)([\w\-._]+)/,
    lookbehind: true,
    alias: 'string'
  },
  key: {
    pattern: /[^\n{[\]},#\s]+[ \t]*:/,
    alias: 'atrule'
  },
  directive: {
    pattern: /(^[ \t]*)%.+/m,
    lookbehind: true,
    alias: 'important'
  },
  punctuation: /[:\-,[\]{}]/
};

// Add these helper functions before the ChatBot component
const looksLikeSQL = (code) => {
  // Common SQL keywords and patterns
  const sqlPatterns = [
    /\b(SELECT|INSERT|UPDATE|DELETE|CREATE|DROP|ALTER|FROM|WHERE|GROUP BY|ORDER BY|JOIN)\b/i,
    /\b(TABLE|DATABASE|INDEX|VIEW|SCHEMA)\b/i,
    /\b(AND|OR|IN|BETWEEN|LIKE|IS NULL|IS NOT NULL)\b/i
  ];
  
  return sqlPatterns.some(pattern => pattern.test(code));
};

const looksLikeYAML = (code) => {
  // Common YAML patterns
  const yamlPatterns = [
    /^[\s-]*[\w-]+:\s*.*$/m,  // key: value pattern
    /^[\s-]*-\s+.*$/m,        // list item pattern
    /^---$/m                  // document separator
  ];
  
  // Check if code has more YAML-like patterns and doesn't look like SQL
  return yamlPatterns.some(pattern => pattern.test(code)) && !looksLikeSQL(code);
};

// Removed formatMessageCache - was causing streaming flicker issues

// Chart processing optimization flags with circuit breaker
let isProcessingCharts = false;
let processingStartTime = 0;
const PROCESSING_TIMEOUT = 5000; // 5 second timeout


// Memoized chart component to prevent unnecessary re-renders
const MemoizedChartComponent = React.memo(({ chartData, chartId, chartType }) => {
  const chartRef = useRef(null);
  
  // Cleanup chart instance on unmount
  useEffect(() => {
    return () => {
      if (chartRef.current && chartRef.current.chart) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        chartRef.current.chart.destroy();
      }
    };
  }, [chartId]);
  
  // Stabilized chart options using useMemo to prevent unnecessary re-renders
  const chartOptions = useMemo(() => {
    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      interaction: {
        mode: 'nearest',
        intersect: true
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      plugins: {
        tooltip: {
          enabled: true,
          mode: 'nearest',
          intersect: true,
          animation: false,
          position: 'nearest'
        },
        legend: {
          position: 'top',
        },
        title: {
          display: false
        }
      },
      scales: {
        y: {
          beginAtZero: true
        }
      }
    };
    
    // Only merge options if they exist and don't cause reference changes
    return defaultOptions;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData.title]);
  
  // Render appropriate chart component with ref for cleanup
  const renderChart = () => {
    switch (chartType.toLowerCase()) {
      case 'line':
        return <Line ref={chartRef} data={chartData.data} options={chartOptions} />;
      case 'pie':
        return <Pie ref={chartRef} data={chartData.data} options={chartOptions} />;
      case 'doughnut':
        return <Doughnut ref={chartRef} data={chartData.data} options={chartOptions} />;
      case 'bar':
      default:
        return <Bar ref={chartRef} data={chartData.data} options={chartOptions} />;
    }
  };
  
  return (
    <div style={{ margin: '15px 0', padding: '15px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #dee2e6', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <div style={{ height: '300px', width: '100%' }}>
        {renderChart()}
      </div>
      {chartData.description && (
        <div style={{ marginTop: '10px', fontSize: '14px', color: '#6c757d', textAlign: 'center' }}>
          {chartData.description}
        </div>
      )}
    </div>
  );
}, (prevProps, nextProps) => {
  // Custom comparison function - return true if props are equal (prevent re-render)
  // Use shallow comparison to avoid expensive JSON.stringify
  const propsEqual = prevProps.chartId === nextProps.chartId && 
                     prevProps.chartType === nextProps.chartType &&
                     prevProps.chartData?.data === nextProps.chartData?.data &&
                     prevProps.chartData?.title === nextProps.chartData?.title;
  return propsEqual;
});

const ChatBot = forwardRef((props, ref) => {
  const { user } = useAuth();
  const { tenants } = useTenantsState();
  const activeTenant = tenants.find((t) => t.tenantId === user?.tenantId);
  const customerName = activeTenant?.name;

  const [messages, setMessages] = useState([{
    text: `Hi ${props.userName || ''}, how can I help you today? 🚀`,
    sender: "gpt",
    isTyping: false,
  }]);
  const [inputMessage, setInputMessage] = useState("");
  const [styledInputVisible, setStyledInputVisible] = useState(true);
  const messageListRef = useRef(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [runningSQL, setRunningSQL] = useState("");
  const [inputHeight, setInputHeight] = useState("auto");
  const [showHistory, setShowHistory] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [loadingConversationId, setLoadingConversationId] = useState(null);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreConversations, setHasMoreConversations] = useState(false);
  const [totalConversations, setTotalConversations] = useState(0);
  const [loadingMore, setLoadingMore] = useState(false);
  const [lastError, setLastError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [conversationToDelete, setConversationToDelete] = useState(null);
  const [isDeletingConversation, setIsDeletingConversation] = useState(false);
  const [selectedAIVersion, setSelectedAIVersion] = useState('v1');
  const [refreshingContext, setRefreshingContext] = useState({
    metadata: false,
    dbt: false,
    datajolt: false
  });
  const isStreamingRef = useRef(false);
  const streamingTextRef = useRef('');
  const streamingUpdateTimeoutRef = useRef(null);
  const abortControllerRef = useRef(null);
  const thinkingTimeoutRef = useRef(null);
  const thinkingClearTimeoutRef = useRef(null);
  const [typingText, setTypingText] = useState('');
  const typingIntervalRef = useRef(null);
  const isTypingActiveRef = useRef(false);
  const [showMetadataDropdown, setShowMetadataDropdown] = useState(false);
  const [metadataSearchTerm, setMetadataSearchTerm] = useState('');
  const [metadataItems, setMetadataItems] = useState([]);
  const [isLoadingMetadata, setIsLoadingMetadata] = useState(false);
  const [cursorPosition, setCursorPosition] = useState(null);
  const inputRef = useRef(null);
  const metadataDropdownRef = useRef(null);
  const [selectedTables, setSelectedTables] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [showContextTypeDropdown, setShowContextTypeDropdown] = useState(false);
  const [selectedContextType, setSelectedContextType] = useState(null);
  const contextTypeDropdownRef = useRef(null);
  const [highlightedContextTypeIndex, setHighlightedContextTypeIndex] = useState(0);
  const [showFilesDropdown, setShowFilesDropdown] = useState(false);
  const [fileSearchTerm, setFileSearchTerm] = useState('');
  const [fileItems, setFileItems] = useState([]);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [highlightedFileIndex, setHighlightedFileIndex] = useState(0);
  const filesDropdownRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [excludeActiveTab, setExcludeActiveTab] = useState(false);
  const [loadingInitialConversation, setLoadingInitialConversation] = useState(false);
  const [showExecutionComplete, setShowExecutionComplete] = useState(false);
  const [showThinking, setShowThinking] = useState(false);
  const [thinkingDots, setThinkingDots] = useState(0);
  const [collapsedPlans, setCollapsedPlans] = useState({});
  const [messagesVisible, setMessagesVisible] = useState(false);
  const [isStreamingComplete, setIsStreamingComplete] = useState(true);
  
  // Datajolt objects dropdown states
  const [showDatajoltDropdown, setShowDatajoltDropdown] = useState(false);
  const [datajoltSearchTerm, setDatajoltSearchTerm] = useState('');
  const [datajoltObjects, setDatajoltObjects] = useState([]);
  const [allDatajoltObjects, setAllDatajoltObjects] = useState([]); // Cache for all datajolt objects
  const [isLoadingDatajolt, setIsLoadingDatajolt] = useState(false);
  const [highlightedDatajoltIndex, setHighlightedDatajoltIndex] = useState(0);
  const datajoltDropdownRef = useRef(null);
  const taskLocalStartTimes = useRef({}); // Track local start times for task timers
  const [selectedDatajoltObjects, setSelectedDatajoltObjects] = useState([]);

  const scrollToUserMessage = () => {
    if (messageListRef.current) {
      // Check if this is the first user message (skip if only greeting exists)
      const userMessages = messageListRef.current.querySelectorAll('.user-message');
      if (userMessages.length <= 1) {
        // First user message - don't scroll, just use normal behavior
        return;
      }
      
      // Find the last user message for scrolling
      const lastUserMessage = userMessages[userMessages.length - 1];
      
      if (lastUserMessage) {
        // Reset any existing margins from previous messages first
        const allGptMessages = messageListRef.current.querySelectorAll('.gpt-message');
        const allUserMessages = messageListRef.current.querySelectorAll('.user-message');
        
        allGptMessages.forEach(msg => msg.style.marginBottom = '16px');
        allUserMessages.forEach(msg => msg.style.marginBottom = '16px');
        
        // Add margin for scrolling space FIRST - prefer GPT message, fallback to user message
        const gptMessages = messageListRef.current.querySelectorAll('.gpt-message');
        const lastGptMessage = gptMessages[gptMessages.length - 1];
        const containerHeight = messageListRef.current.clientHeight;
        
        if (lastGptMessage) {
          // GPT response exists - apply margin to it
          lastGptMessage.style.marginBottom = `${containerHeight}px`;
        } else {
          // No GPT response yet - apply margin to user message temporarily
          lastUserMessage.style.marginBottom = `${containerHeight}px`;
        }
        
        // THEN scroll to position user message at top (now has space to work with)
        setTimeout(() => {
          lastUserMessage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  };

  const adjustBottomPadding = () => {
    if (messageListRef.current) {
      // Get the current AI response height and adjust margins
      const gptMessages = messageListRef.current.querySelectorAll('.gpt-message');
      const lastGptMessage = gptMessages[gptMessages.length - 1];
      
      if (lastGptMessage) {
        // Transfer margin from user message to GPT message if needed
        const userMessages = messageListRef.current.querySelectorAll('.user-message');
        const lastUserMessage = userMessages[userMessages.length - 1];
        if (lastUserMessage && lastUserMessage.style.marginBottom && lastUserMessage.style.marginBottom !== '16px') {
          // Reset user message margin since GPT response now exists
          lastUserMessage.style.marginBottom = '16px';
        }
        
        const responseHeight = lastGptMessage.offsetHeight;
        const containerHeight = messageListRef.current.clientHeight;
        
        // Calculate remaining margin (original container height minus current response height)
        const remainingMargin = Math.max(16, containerHeight - responseHeight);
        lastGptMessage.style.marginBottom = `${remainingMargin}px`;
      }
    }
  };

  // Live timer updates for running tasks - only when needed
  useEffect(() => {
    const interval = setInterval(() => {
      setMessages(prevMessages => {
        const hasRunningTasks = prevMessages.some(message => 
          message.tasks && message.tasks.some(task => task.status === 'in_progress' && task.start_time)
        );
        
        // Only update if there are actually running tasks
        if (hasRunningTasks) {
          return prevMessages.map(message => {
            if (message.tasks && message.tasks.some(task => task.status === 'in_progress' && task.start_time)) {
              // Create new object only when there are running tasks
              return { ...message, lastTimerUpdate: Date.now() };
            }
            return message;
          });
        }
        
        // Return same reference if no running tasks - prevents unnecessary re-renders
        return prevMessages;
      });
    }, 1000); // Update every second

    return () => clearInterval(interval);
  }, []);

  // Load datajolt objects once on component mount
  useEffect(() => {
    loadDatajoltObjects();
  }, []);

  // Removed empty useEffect that was causing re-renders
  // useEffect(() => {
  //   // Messages updated
  // }, [messages]);

  // Removed empty useEffect that was causing re-renders
  // useEffect(() => {
  //   // Handle lastError changes
  //   if (lastError) {
  //     // Error occurred
  //   }
  // }, [lastError]);

  // Animate thinking dots
  useEffect(() => {
    if (showThinking) {
      const interval = setInterval(() => {
        setThinkingDots(prev => (prev + 1) % 4); // Cycle 0-3 dots
      }, 500);
      return () => clearInterval(interval);
    } else {
      setThinkingDots(0); // Reset when not thinking
    }
  }, [showThinking]);

  // Typing animation function with dynamic target text updates
  const targetTextRef = useRef('');
  const currentIndexRef = useRef(0);
  const lastProcessedPositionRef = useRef(0);
  
  const startTypingAnimation = (initialText) => {
    targetTextRef.current = initialText;
    currentIndexRef.current = 0;
    setTypingText('');
    
    if (typingIntervalRef.current) {
      clearInterval(typingIntervalRef.current);
    }
    
    typingIntervalRef.current = setInterval(() => {
      const currentTargetText = streamingTextRef.current; // Always use latest text
      const currentIndex = currentIndexRef.current;

      // Use Array.from to properly handle multi-codepoint characters (emojis)
      // substring() breaks surrogate pairs, causing invalid characters
      const chars = Array.from(currentTargetText);

      if (currentIndex < chars.length) {
        const newText = chars.slice(0, currentIndex + 1).join('');
        setTypingText(newText);
        currentIndexRef.current++;
        // Log every 50 chars to avoid spam
        if (currentIndex % 50 === 0) {
          console.log('[TYPING DEBUG] Progress:', currentIndex, '/', chars.length, 'Text:', newText.substring(0, 30));
        }
      } else {
        // Check if streaming has finished
        if (!isStreamingRef.current) {
          console.log('[TYPING DEBUG] Streaming finished, clearing animation. Final text length:', chars.length);
          clearInterval(typingIntervalRef.current);
          typingIntervalRef.current = null;
          isTypingActiveRef.current = false;

          // Clear the typing animation flag when done
          setMessages(prevMessages => {
            const newMessages = [...prevMessages];
            const lastMessage = newMessages[newMessages.length - 1];
            if (lastMessage && lastMessage.isTypingAnimation) {
              newMessages[newMessages.length - 1] = {
                ...lastMessage,
                isTypingAnimation: false
              };
            }
            return newMessages;
          });
        }
        // If still streaming, just wait for more text
      }
    }, 1); // 2ms per character (very fast typing animation)
  };

  // Cleanup typing animation on unmount
  useEffect(() => {
    return () => {
      if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
      }
    };
  }, []);


  useImperativeHandle(ref, () => ({
    startFix: (lastError, isNewPage = false) => {
      if(lastError) {
        if(isNewPage || showHistory) {
          setShowHistory(false);
          newChat();
          // Process error after chat reset is complete
          setTimeout(() => {
            const errorMessage = `The following SQL:\n\`\`\`sql\n${lastError.sql_code}\n\`\`\`\n\nReturns this error:\n\`\`\`\n${lastError.error_message}\n\`\`\`\n\nHelp me fix it.`;
            submitMessage(errorMessage);
          }, 100);
          return;
        }
      }
      const errorMessage = `The following SQL:\n\`\`\`sql\n${lastError.sql_code}\n\`\`\`\n\nReturns this error:\n\`\`\`\n${lastError.error_message}\n\`\`\`\n\nHelp me fix it.`;
      submitMessage(errorMessage);

      if(!isNewPage) {
        // Page navigation handled
      }
    },
    
    showError: (errorData) => {
      if (!errorData) {
        setLastError(null);
        return;
      }
      
      // Make sure we have the correct structure
      const lastError = {
        sql_code: errorData.sql_code || '',
        error_message: errorData.error_message || ''
      };
      
      setLastError(lastError);
    }
  }));

  const stopStreaming = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    isStreamingRef.current = false;
    setIsStreamingComplete(true); // Mark streaming as complete when stopped
    
    // Reset margins on both user and GPT messages when cancelled
    if (messageListRef.current) {
      const gptMessages = messageListRef.current.querySelectorAll('.gpt-message');
      const lastGptMessage = gptMessages[gptMessages.length - 1];
      if (lastGptMessage) {
        lastGptMessage.style.marginBottom = '16px';
      }
      
      const userMessages = messageListRef.current.querySelectorAll('.user-message');
      const lastUserMessage = userMessages[userMessages.length - 1];
      if (lastUserMessage) {
        lastUserMessage.style.marginBottom = '16px';
      }
    }
    
    // Clear all timeouts
    if (thinkingTimeoutRef.current) {
      clearTimeout(thinkingTimeoutRef.current);
      thinkingTimeoutRef.current = null;
    }
    if (thinkingClearTimeoutRef.current) {
      clearTimeout(thinkingClearTimeoutRef.current);
      thinkingClearTimeoutRef.current = null;
    }
    if (streamingUpdateTimeoutRef.current) {
      clearTimeout(streamingUpdateTimeoutRef.current);
      streamingUpdateTimeoutRef.current = null;
    }
    
    // Clear all loading states
    setShowThinking(false);
    setShowExecutionComplete(false);
    setThinkingDots(0);
    
    // Clear typing animation
    if (typingIntervalRef.current) {
      clearInterval(typingIntervalRef.current);
      typingIntervalRef.current = null;
    }
    isTypingActiveRef.current = false;
    
    // Add cancellation message to the current bot message and update running tasks
    setMessages(prevMessages => {
      const newMessages = [...prevMessages];
      const lastMessage = newMessages[newMessages.length - 1];
      if (lastMessage && lastMessage.sender === "gpt") {
        // Update any in_progress tasks to error status
        const updatedTasks = lastMessage.tasks ? lastMessage.tasks.map(task => 
          task.status === 'in_progress' ? { ...task, status: 'error' } : task
        ) : lastMessage.tasks;
        
        newMessages[newMessages.length - 1] = {
          ...lastMessage,
          text: (lastMessage.text || '') + '\n\n*-- USER CANCELLED --*',
          isTyping: false,
          isTypingAnimation: false,
          tasks: updatedTasks
        };
      }
      return newMessages;
    });
  };

  const submitMessage = async (messageText) => {
    const trimmedMessageText = messageText.trim();
    if (trimmedMessageText === "") {
      return;
    }

    const userMessage = { text: trimmedMessageText, sender: "user" };
    const typingMessage = { text: "", sender: "gpt", isTyping: true };
    const updatedMessages = [...messages, userMessage];

    setMessages([...updatedMessages, typingMessage]);
    setShowThinking(true); // Show thinking dots while waiting for Claude response
    
    // Reset typing animation state for new conversation
    if (typingIntervalRef.current) {
      clearInterval(typingIntervalRef.current);
      typingIntervalRef.current = null;
    }
    isTypingActiveRef.current = false;
    currentIndexRef.current = 0;
    setTypingText('');
    streamingTextRef.current = '';
    
    // Scroll to position user message at top with space below
    setTimeout(() => scrollToUserMessage(), 100);

    try {
      // Use selectedFiles for context instead of building from props.files
      const context = {
        files: selectedFiles.map(file => {
          // Get content from props.files if available
          const content = props.files && props.files[file.name] ? props.files[file.name] : '';
          return {
            name: file.name,
            content,
            isActive: file.name === props.activeTab
          };
        }),
        activeTab: props.activeTab
      };

      const payload = {
        messages: updatedMessages.slice(-20),
        conversation_id: localStorage.getItem('conversation_id'),
        context,
        mode: props.mode || 'default',
        selected_text: props.selectedText,
        selected_files: selectedFiles.map(file => file.name),
        selected_tables: selectedTables.length > 0 ? selectedTables.map(table => {
          // Get the columns with their data types from the dwh_structure
          const columns = props.dwh_structure?.[table.schema]?.[table.displayName] || [];
          return {
            name: table.name,
            schema: table.schema,
            table: table.displayName,
            columns: columns
          };
        }) : undefined
      };
      console.log('Payload:', payload);
      console.log('Starting request at:', new Date().toISOString());
      
      isStreamingRef.current = true;
      lastProcessedPositionRef.current = 0; // Reset processed position for new request
      setShowExecutionComplete(false); // Reset execution complete state
      setCollapsedPlans({}); // Reset execution plan collapsed state
      setIsStreamingComplete(false); // Mark streaming as not complete
      
      // Create abort controller for this request
      abortControllerRef.current = new AbortController();
      
      // Use fetch with ReadableStream for reliable SSE streaming (axios onDownloadProgress is unreliable)
      const response = await fetch(`${config.url.AI_URL}/api/ai/ask_question`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken') || ''}`
        },
        body: JSON.stringify(payload),
        signal: abortControllerRef.current.signal
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const processLine = (line) => {
        if (!line.startsWith('data: ')) return;
        if (!isStreamingRef.current) {
          console.log('[STREAM DEBUG] Streaming disabled, skipping line');
          return;
        }

        try {
          const jsonStr = line.slice(6);
          if (jsonStr === '[DONE]') {
            console.log('[STREAM DEBUG] Received [DONE] signal');
            return;
          }

          const data = JSON.parse(jsonStr);
          console.log('[STREAM DEBUG] Parsed data:', JSON.stringify(data).substring(0, 100));

          // Handle incremental text streaming (delta updates)
          if (data.text_delta && (!data.tasks || data.tasks.length === 0)) {
            const filteredDelta = data.text_delta;
            console.log('[STREAM DEBUG] text_delta received:', JSON.stringify(filteredDelta), 'Total text now:', streamingTextRef.current.length + filteredDelta.length);

            streamingTextRef.current += filteredDelta;
            setMessages(prevMessages => {
              const newMessages = [...prevMessages];
              const lastMessage = newMessages[newMessages.length - 1];

              if (!isTypingActiveRef.current && streamingTextRef.current.length > 0) {
                startTypingAnimation(streamingTextRef.current);
                isTypingActiveRef.current = true;
              }

              newMessages[newMessages.length - 1] = {
                ...lastMessage,
                text: streamingTextRef.current,
                sender: "gpt",
                isTyping: streamingTextRef.current.length === 0,
                isTypingAnimation: true,
                hasResult: lastMessage.tasks?.length > 0 ? true : lastMessage.hasResult
              };
              return newMessages;
            });

            setTimeout(() => adjustBottomPadding(), 50);
            return;
          }

          // Handle task list - backend sends complete state
          if (data.tasks) {
            clearTimeout(streamingUpdateTimeoutRef.current);
            setMessages(prevMessages => {
              const newMessages = [...prevMessages];
              const existingMessage = newMessages[newMessages.length - 1];

              newMessages[newMessages.length - 1] = {
                ...existingMessage,
                text: data.text !== undefined ? data.text : existingMessage.text,
                tasks: data.tasks,
                execution_start_time: data.execution_start_time || existingMessage.execution_start_time,
                sender: "gpt",
                isTyping: !data.tasks || data.tasks.length === 0,
                isTypingAnimation: existingMessage.isTypingAnimation
              };
              return newMessages;
            });

            const allCompleted = data.tasks.every(task =>
              task.status === 'completed' || task.status === 'error'
            );
            if (allCompleted) {
              setShowExecutionComplete(true);
              thinkingTimeoutRef.current = setTimeout(() => {
                setShowExecutionComplete(false);
                setShowThinking(true);
              }, 1000);
            }
          }

          // Handle execution timing updates
          if (data.execution_timing) {
            setMessages(prevMessages => {
              const newMessages = [...prevMessages];
              const lastMessage = newMessages[newMessages.length - 1];

              newMessages[newMessages.length - 1] = {
                ...lastMessage,
                execution_start_time: data.execution_timing.execution_start_time,
                execution_end_time: data.execution_timing.execution_end_time,
                execution_duration: data.execution_timing.execution_duration
              };
              return newMessages;
            });
          }

          // Handle final response start (remove task list)
          if (data.text && data.text.includes('---')) {
            clearTimeout(streamingUpdateTimeoutRef.current);
            streamingTextRef.current = '';
            setShowExecutionComplete(false);
            setShowThinking(false);

            setMessages(prevMessages => {
              const newMessages = [...prevMessages];
              const lastMessage = newMessages[newMessages.length - 1];
              newMessages[newMessages.length - 1] = {
                ...lastMessage,
                text: '',
                sender: "gpt",
                isTyping: false,
                isTypingAnimation: true,
                hasResult: true
              };
              return newMessages;
            });
            return;
          }

          if (data.done) {
            console.log('Stream complete');
            console.log('Data:', data);
            isStreamingRef.current = false;
            abortControllerRef.current = null;
            setIsStreamingComplete(true);

            clearTimeout(streamingUpdateTimeoutRef.current);
            // Clear thinking state on any completion
            setShowThinking(false);
            setShowExecutionComplete(false);
            if (thinkingTimeoutRef.current) {
              clearTimeout(thinkingTimeoutRef.current);
              thinkingTimeoutRef.current = null;
            }
            setCollapsedPlans(prev => ({ ...prev, [messages.length - 1]: true }));

            // Show error message if stream completed with error
            if (data.completion_status === 'error' || data.completion_status === 'rate_limit_error') {
              setMessages(prevMessages => {
                const newMessages = [...prevMessages];
                const lastMessage = newMessages[newMessages.length - 1];
                newMessages[newMessages.length - 1] = {
                  ...lastMessage,
                  text: data.text || 'Error: Could not fetch response from Robin.',
                  sender: "gpt",
                  isTyping: false,
                  isTypingAnimation: false,
                };
                return newMessages;
              });
            }

            if (data.conversation_id) {
              localStorage.setItem('conversation_id', data.conversation_id);
            }
          }
        } catch (e) {
          console.error('[STREAM DEBUG] Error processing response:', e);
          console.error('[STREAM DEBUG] Failed line was:', line);
        }
      };

      // Read the stream
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          console.log('[STREAM DEBUG] Stream ended');
          // Process any remaining buffer
          if (buffer.trim()) {
            buffer.split('\n').forEach(line => processLine(line.trim()));
          }
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || ''; // Keep incomplete line in buffer

        for (const line of lines) {
          if (line.trim()) {
            processLine(line.trim());
          }
        }
      }

      // Keep only the active tab in selectedFiles
      if (props.activeTab) {
        const activeTabFile = selectedFiles.find(file => file.name === props.activeTab);
        setSelectedFiles(activeTabFile ? [activeTabFile] : []);
      } else {
        setSelectedFiles([]);
      }
      
      // Clear selected tables after sending the message
      setSelectedTables([]);

    } catch (error) {
      isStreamingRef.current = false;
      abortControllerRef.current = null;
      setIsStreamingComplete(true); // Mark streaming as complete on error
      clearTimeout(streamingUpdateTimeoutRef.current); // Clean up on error
      // Clear any pending thinking state timeouts
      if (thinkingTimeoutRef.current) {
        clearTimeout(thinkingTimeoutRef.current);
        thinkingTimeoutRef.current = null;
      }
      if (thinkingClearTimeoutRef.current) {
        clearTimeout(thinkingClearTimeoutRef.current);
        thinkingClearTimeoutRef.current = null;
      }
      // Clear all loading states
      setShowThinking(false);
      setShowExecutionComplete(false);
      console.error("Error calling Robin API:", error);
      // Extract response code and show specific error message
      const responseCode = error.response?.status || 'unknown';
      setMessages(prevMessages => [
        ...prevMessages.slice(0, -1),
        { text: `Robin was unable to process your request (response code ${responseCode}). Contact Datajolt on Slack.`, sender: "gpt", isTyping: false }
      ]);
      
      // Still clear selected tables and keep only active tab even if there's an error
      if (props.activeTab) {
        const activeTabFile = selectedFiles.find(file => file.name === props.activeTab);
        setSelectedFiles(activeTabFile ? [activeTabFile] : []);
      } else {
        setSelectedFiles([]);
      }
      setSelectedTables([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedInputMessage = inputMessage.trim();
    if (trimmedInputMessage === "") {
      return;
    }

    // Clear input field and call submitMessage
    setInputMessage("");
    setInputHeight("auto");
    await submitMessage(trimmedInputMessage);
  };

  const handleCopy = async (code, index) => {
    console.log('🎯 Copy clicked! Index:', index);
    await navigator.clipboard.writeText(code.trim());
    
    // Simplified: just set the state
    setCopiedIndex(index);
    console.log('🎯 Set copiedIndex to:', index);

    // Reset after 2 seconds
    setTimeout(() => {
      setCopiedIndex(null);
      console.log('🎯 Reset copiedIndex to null');
    }, 2000);
  };

  const handleRunSQL = async (sql, index) => {
    console.log('🚀 Run SQL clicked! Index:', index, 'SQL length:', sql.length);
    // Remove AI-generated code markers like "// ... existing code ..."
    const cleanedSQL = sql.replace(/\/\/\s*\.{3}\s*existing\s+code\s*\.{3,}\s*/gi, '');
    props.updateSelectedText(cleanedSQL.trim(), async () => {
      try {
        setRunningSQL(index); // Set loading state before running SQL
        console.log('🚀 Set runningSQL to:', index);
        await props.runSQL(); // Wait for SQL execution
        console.log('🚀 SQL execution complete');
      } catch (error) {
        console.error("Error executing SQL:", error);
        toast.error("Failed to execute SQL");
      } finally {
        setRunningSQL(""); // Always reset loading state when done
        console.log('🚀 Reset runningSQL to empty string');
      }
    });
  };
  
  const formatMessage = (text, chatIndex, isStreaming = false) => {
    // Debug: Check if formatMessage is being called
    if (copiedIndex) {
      console.log('📝 formatMessage called with copiedIndex:', copiedIndex, 'for chatIndex:', chatIndex);
      console.log('📝 Text length:', text?.length, 'contains ```:', text?.includes('```'));
    }
    
    // Processing guard with circuit breaker to prevent infinite loops
    if (isProcessingCharts) {
      const currentTime = Date.now();
      if (currentTime - processingStartTime > PROCESSING_TIMEOUT) {
        console.warn('🚨 Chart processing timeout - resetting');
        isProcessingCharts = false;
        processingStartTime = 0;
      } else {
        return "📊 Processing chart...";
      }
    }
    
    // No caching - let React handle diffing naturally
    
    if (!text) return "";
    
    // Set processing flag to prevent concurrent execution
    isProcessingCharts = true;
    processingStartTime = Date.now();
    
    // STEP 0: Handle incomplete charts during streaming
    if (isStreaming && text.includes(':::')) {
      const tripleColonCount = (text.match(/:::/g) || []).length;
      const incompleteChart = tripleColonCount === 1; // Only opening :::, no closing
      
      if (incompleteChart) {
        console.log('⏳ Incomplete chart detected during streaming, showing loading text');
        isProcessingCharts = false;
        
        // Show text before chart + styled loading box
        const textBeforeChart = text.substring(0, text.indexOf(':::'));
        
        return (
          <div>
            {formatTextMessage(textBeforeChart, chatIndex)}
            <div className="chart-loading-modern">
              <div className="chart-loading-text">
                <Spinner animation="border" size="sm" variant="primary" />
                Chart loading...
              </div>
            </div>
          </div>
        );
      }
    }
    
    
    
    // STEP 1: Hide ALL chart markers immediately and replace with loading or charts
    // This ensures users NEVER see :::chart text
    let hasCharts = false;
    
    // First, replace all chart markers with placeholders
    let processedText = text
      .replace(/:::chart-loading\s*:::/gs, () => {
        hasCharts = true;
        return '<div class="chart-loading">📊 Charting...</div>';
      })
      .replace(/:::chart-replace\s*(.*?)\s*:::/gs, (match, chartJson) => {
        hasCharts = true;
        try {
          const chartData = JSON.parse(chartJson);
          const chartDataBase64 = btoa(JSON.stringify(chartData));
          return `<div class="chart-placeholder" data-chart-base64='${chartDataBase64}' data-chart-id="chart-${chatIndex}-${JSON.stringify(chartData).length}"></div>`;
        } catch (e) {
          console.error('Chart replace parsing error:', e);
          return '<div class="chart-loading">📊 Charting...</div>';
        }
      })
      .replace(/:::chart\s*(.*?)\s*:::/gs, (match, chartJson) => {
        hasCharts = true;
        
        // Check if this looks like incomplete chart data (common during streaming)
        if (chartJson.trim().length < 50 || !chartJson.includes('"type"') || !chartJson.includes('"data"')) {
          console.log('⏳ Incomplete chart data detected, showing loading state');
          return '<div class="chart-loading">📊 Loading Chart...</div>';
        }
        
        try {
          const chartData = JSON.parse(chartJson);
          
          const chartId = `chart-${chatIndex}-${JSON.stringify(chartData).length}`;
          
          const chartDataBase64 = btoa(JSON.stringify(chartData));
          const placeholderHtml = `<div class="chart-placeholder" data-chart-base64='${chartDataBase64}' data-chart-id="${chartId}" style="min-height: 300px; background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 8px; display: flex; align-items: center; justify-content: center; margin: 15px 0;">📊 Loading Chart...</div>`;
          return placeholderHtml;
        } catch (e) {
          console.error('Chart parsing error:', e);
          console.error('Raw chart JSON length:', chartJson?.length);
          console.error('Raw chart JSON preview:', chartJson?.substring(0, 200) + '...');
          console.error('Raw chart JSON ending:', '...' + chartJson?.substring(chartJson.length - 200));
          
          // For JSON parse errors during streaming, show loading instead of error (be more aggressive)
          if (e.message.includes('Unterminated string') || 
              e.message.includes('Unexpected end') ||
              e.message.includes('position') ||
              chartJson.length < 100 ||
              !chartJson.includes('}')) {
            console.log('⏳ JSON appears truncated/incomplete, showing loading state instead of error');
            return '<div class="chart-loading">📊 Loading Chart...</div>';
          }
          
          return '<div class="chart-error" style="color: #dc3545; padding: 15px; background: #f8d7da; border: 1px solid #f5c6cb; border-radius: 8px; margin: 15px 0;">❌ Chart rendering failed - Invalid JSON format</div>';
        }
      });

    
    // STEP 2: If we have charts, render mixed content  
    if (hasCharts) {
      const parts = processedText.split(/(<div class="chart-(?:placeholder|loading)"[^>]*>.*?<\/div>)/);
      
      const result = parts.map((part, index) => {
        
        if (part.includes('chart-placeholder')) {
          // Extract and render actual chart
          const chartMatch = part.match(/data-chart-base64='([^']*)'.*data-chart-id="([^"]*)"/);
          if (chartMatch) {
            try {
              const chartData = JSON.parse(atob(chartMatch[1]));
              const chartId = chartMatch[2];
              
              
              // Validate chart data structure
              if (!chartData.data || !chartData.data.datasets) {
                console.error('❌ Invalid chart data structure:', chartData);
                return (
                  <div key={chartId} style={{ margin: '15px 0', padding: '15px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '8px', color: '#856404' }}>
                    ⚠️ Chart data missing or invalid format
                  </div>
                );
              }
              
              // Determine chart type (default to bar)
              const chartType = chartData.type || 'bar';
              
              // Use memoized component to prevent unnecessary re-renders
              return (
                <MemoizedChartComponent 
                  key={chartId}
                  chartData={chartData}
                  chartId={chartId}
                  chartType={chartType}
                />
              );
            } catch (e) {
              console.error('❌ Chart rendering error:', e);
              console.error('Chart match data:', chartMatch);
              console.error('Raw chart JSON from match:', chartMatch?.[1]?.substring(0, 200) + '...');
              return (
                <div key={index} style={{ margin: '15px 0', padding: '15px', backgroundColor: '#f8d7da', border: '1px solid #f5c6cb', borderRadius: '8px', color: '#721c24' }}>
                  <strong>❌ Chart Rendering Failed</strong>
                  <br />
                  <small>Error: {e.message}</small>
                  <br />
                  <small>Check browser console for details</small>
                </div>
              );
            }
          }
        } else if (part.includes('chart-loading')) {
          // Show loading spinner
          return (
            <div key={index} style={{ 
              margin: '15px 0', 
              padding: '20px', 
              backgroundColor: '#fafbfc', 
              borderRadius: '8px', 
              border: '1px solid #e2e8f0', 
              textAlign: 'center', 
              color: '#666' 
            }}>
              <div style={{
                display: 'inline-block',
                marginRight: '8px',
                width: '16px',
                height: '16px',
                border: '2px solid #e2e8f0',
                borderTop: '2px solid #3b82f6',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
              Charting...
            </div>
          );
        }
        
        // Regular text part - use formatTextMessage to preserve markdown
        return part.trim() ? (
          <div key={`text-${index}`}>
            {formatTextMessage(part, `${chatIndex}-${index}`)}
          </div>
        ) : null;
      }).filter(Boolean);
      
      // Return result without caching
      isProcessingCharts = false;
      return result;
    }
    
    // STEP 3: No charts, just render with formatTextMessage to preserve all markdown formatting
    const result = formatTextMessage(text, chatIndex);
    
    // Return result without caching
    isProcessingCharts = false;
    return result;
  };
  
  const formatTextMessage = (text, chatIndex) => {
    if (!text) return "";

    const processText = (text) => {
      return text
        .replace(/(https?:\/\/[^\s]+)/g, (url) => 
          `<a href="${url}" target="_blank" rel="noopener noreferrer">here</a>`)
        .replace(/<CreateFolderActionButton>(.*?)<\/CreateFolderActionButton>/g, (_, buttonText) => {
          return `<button class="create-folder-btn">${buttonText}</button>`;
        });
    };

    // Only add closing backticks if there's an unmatched opening block
    // Parse code blocks from FULL text for stable buttons
    const openCodeBlocks = (text.match(/```/g) || []).length;
    let processedText = text;
    if (openCodeBlocks % 2 === 1) {
      processedText = text + '\n```';
    }

    const parts = processedText.split(/(```[\s\S]*?```)/);
    
    return parts.map((part, index) => {
      
      if (part.startsWith("```")) {
        // Debug: We found a code block!
        if (copiedIndex) {
          console.log('🔍 PROCESSING CODE BLOCK - part index:', index, 'chatIndex:', chatIndex);
        }
        const match = part.match(/```(\w+)?\n?([\s\S]*?)```/);
        if (match) {
          const [, language, code] = match;
          const declaredLang = language?.toLowerCase();
          
          const isSQL = declaredLang === 'sql';
          const isYAML = declaredLang === 'yaml' || declaredLang === 'yml';
          const autoDetectedSQL = !declaredLang && looksLikeSQL(code);
          const autoDetectedYAML = !declaredLang && looksLikeYAML(code);

          // Process the code without HTML wrapping
          const processedCode = code.trim();
          
          // Don't highlight incomplete code blocks (last block in streaming)
          const isIncompleteBlock = index === parts.length - 1 && !text.endsWith('```');
          const formattedCode = isIncompleteBlock ? processedCode :
            (isSQL || autoDetectedSQL)
              ? Prism.highlight(processedCode, Prism.languages.sql, "sql")
              : (isYAML || autoDetectedYAML)
              ? Prism.highlight(processedCode, Prism.languages.yaml, "yaml")
              : processedCode;

          const isCopied = copiedIndex === `${chatIndex}-${index}`;
          const isRunning = runningSQL === `${chatIndex}-${index}`;
          
          // Debug logging - show all code blocks to see the issue
          const currentIndex = `${chatIndex}-${index}`;
          if (copiedIndex) { // Show all when there's a copied state
            console.log('🔍 CODE BLOCK:', currentIndex, 'copiedIndex:', copiedIndex, 'match:', copiedIndex === currentIndex, 'isCopied:', isCopied);
          }
          const isUserMessage = messages[chatIndex]?.sender === "user";
          const isDiffViewActive = props.isDiffViewActive;
          const selectedText = props.selectedText;

          return (
            <div key={index} className="code-block-wrapper" style={{ marginBottom: '10px' }}>
              {(isSQL || isYAML) && !isUserMessage && props.runSQL && (
                <div className="code-actions">
                  <Tooltip title={isCopied ? "Code copied ✓" : "Copy code"}>
                    <button
                      key={`${currentIndex}-${isCopied}`} // Force re-render when state changes
                      className={`code-action-btn ${isCopied ? 'copied-success' : ''}`}
                      onClick={() => handleCopy(code, `${chatIndex}-${index}`)}
                    >
                      {isCopied ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={14} height={14}>
                          <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/>
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          fill="#fff"
                          width={14}
                        >
                          <path d="M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z" />
                        </svg>
                      )}
                    
                    </button>
                  </Tooltip>
                  {(isSQL || autoDetectedSQL) && (
                    <Tooltip title={isRunning ? "SQL Query is running..." : "Run SQL"}>
                      <button
                        className={`code-action-btn ${
                          isRunning ? "running" : ""
                        }`}
                        onClick={() =>
                          handleRunSQL(code, `${chatIndex}-${index}`)
                        }
                        disabled={runningSQL !== ""}
                      >
                        {isRunning ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <Play size={14} fill="white" />
                        )}
                      </button>
                    </Tooltip>
                  )}
                  <Tooltip
                    title={isDiffViewActive ? "Accept / Reject displayed changes first" : `Apply ${isSQL || autoDetectedSQL ? 'SQL' : 'YAML'}`}
                  >
                    <button
                      className="code-action-btn"
                      onClick={() => {
                        handleApplySQL(code);
                      }}
                      disabled={isDiffViewActive}
                    >
                      <Check size={14} strokeWidth={4} />
                    </button>
                  </Tooltip>
                </div>
              )}
              <pre>
                {isSQL || autoDetectedSQL ? (
                  <code
                    className="language-sql"
                    dangerouslySetInnerHTML={{ __html: formattedCode }}
                  />
                ) : isYAML || autoDetectedYAML ? (
                  <code
                    className="language-yaml"
                    dangerouslySetInnerHTML={{ __html: formattedCode }}
                  />
                ) : (
                  <code className={language ? `language-${language}` : ""}>
                    {code.trim()}
                  </code>
                )}
              </pre>
            </div>
          );
        }
      }
      
      return (
        <div 
          key={index} 
          style={{ 
            lineHeight: '1.4',
            fontSize: '11px'
          }}
          className="markdown-content"
        >
          <ReactMarkdown 
            remarkPlugins={[remarkGfm, remarkBreaks, remarkEmoji]}
            components={{
            // Custom link renderer to handle the existing link processing
            a: ({ href, children, ...props }) => (
              <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
                {children}
              </a>
            ),
            // Minimal paragraph spacing
            p: ({ children, node }) => {
              // Check if this paragraph is inside a list item
              const isInListItem = node?.parent?.tagName === 'li';
              // Check if next sibling is a list to reduce spacing
              const nextSiblingIsList = node?.nextSibling && ['ul', 'ol'].includes(node.nextSibling.tagName);
              
              // For list items, return just the children without <p> wrapper
              if (isInListItem) {
                return <span style={{ lineHeight: '1.5' }}>{children}</span>;
              }
              
              return (
                <p style={{ 
                  margin: nextSiblingIsList ? '0 0 0px 0' : '0 0 1px 0',
                  lineHeight: '1.5'
                }}>
                  {children}
                </p>
              );
            },
            // Ultra-compact list rendering
            ul: ({ children }) => <ul style={{ margin: '0', paddingLeft: '24px', lineHeight: '1.4' }}>{children}</ul>,
            ol: ({ children }) => <ol style={{ 
              margin: '0', 
              paddingLeft: '24px',
              lineHeight: '1.4',
              listStylePosition: 'outside'
            }}>{children}</ol>,
            // Minimal list item spacing with proper alignment
            li: ({ children }) => {
              const renderedChildren = children && children.length > 0 && children[0] === "\n" ? children.slice(1) : children;

              return (
                <li style={{ 
                  margin: '0 0 2px 0', 
                  lineHeight: '1.4', 
                  display: 'list-item',
                  listStylePosition: 'outside',
                  textAlign: 'left',
                  paddingLeft: '0px'
                }}><div>{renderedChildren}</div></li>
              )
          },
            // Compact heading rendering
            h1: ({ children }) => <h1 style={{ margin: '12px 0 6px 0', fontSize: '1.4em', fontWeight: 'bold', lineHeight: '1.3' }}>{children}</h1>,
            h2: ({ children }) => <h2 style={{ margin: '10px 0 4px 0', fontSize: '1.25em', fontWeight: 'bold', lineHeight: '1.3' }}>{children}</h2>,
            h3: ({ children }) => <h3 style={{ margin: '8px 0 4px 0', fontSize: '1.15em', fontWeight: 'bold', lineHeight: '1.3' }}>{children}</h3>,
            h4: ({ children }) => <h4 style={{ margin: '6px 0 2px 0', fontSize: '1.05em', fontWeight: 'bold', lineHeight: '1.3' }}>{children}</h4>,
            h5: ({ children }) => <h5 style={{ margin: '6px 0 2px 0', fontSize: '1em', fontWeight: 'bold', lineHeight: '1.3' }}>{children}</h5>,
            h6: ({ children }) => <h6 style={{ margin: '6px 0 2px 0', fontSize: '0.95em', fontWeight: 'bold', lineHeight: '1.3' }}>{children}</h6>,
            // Compact blockquote rendering
            blockquote: ({ children }) => (
              <blockquote style={{ 
                margin: '6px 0', 
                paddingLeft: '12px', 
                borderLeft: '3px solid #ddd',
                fontStyle: 'italic',
                color: '#666',
                lineHeight: '1.4'
              }}>
                {children}
              </blockquote>
            ),
            // Compact text formatting
            strong: ({ children }) => <strong style={{ fontWeight: 'bold' }}>{children}</strong>,
            em: ({ children }) => <em style={{ fontStyle: 'italic' }}>{children}</em>,
            // Handle CreateFolderActionButton processing
            text: ({ value }) => {
              if (typeof value === 'string' && value.includes('<CreateFolderActionButton>')) {
                const processedValue = value.replace(
                  /<CreateFolderActionButton>(.*?)<\/CreateFolderActionButton>/g, 
                  '<button class="create-folder-btn">$1</button>'
                );
                return <span dangerouslySetInnerHTML={{ __html: processedValue }} />;
              }
              return value;
            }
          }}
        >
          {part
            .replace(/<strong>(.*?)<\/strong>/g, '**$1**')
            .replace(/<em>(.*?)<\/em>/g, '*$1*')
          }
        </ReactMarkdown>
        </div>
      );
    });
  };

  const handleApplySQL = (sql) => {
    if (props.showDiffInEditor) {
      props.showDiffInEditor(sql.trim());
    }
  };


  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      if (showContextTypeDropdown) {
        e.preventDefault();
        // Select the highlighted context type
        const contextTypes = ['datajolt', 'files', 'metadata'];
        if (highlightedContextTypeIndex >= 0 && highlightedContextTypeIndex < contextTypes.length) {
          handleContextTypeSelect(contextTypes[highlightedContextTypeIndex]);
        }
      } else if (showFilesDropdown && fileItems.length > 0) {
        e.preventDefault();
        // Select the highlighted file
        if (highlightedFileIndex >= 0 && highlightedFileIndex < fileItems.length) {
          handleFileItemSelect(fileItems[highlightedFileIndex]);
        }
      } else if (showMetadataDropdown && metadataItems.length > 0) {
        e.preventDefault();
        // Select the highlighted item
        if (highlightedIndex >= 0 && highlightedIndex < metadataItems.length) {
          handleMetadataItemSelect(metadataItems[highlightedIndex]);
        }
      } else if (showDatajoltDropdown && datajoltObjects.length > 0) {
        e.preventDefault();
        // Select the highlighted datajolt object
        if (highlightedDatajoltIndex >= 0 && highlightedDatajoltIndex < datajoltObjects.length) {
          handleDatajoltObjectSelect(datajoltObjects[highlightedDatajoltIndex]);
        }
      } else {
        // If streaming, allow Enter to create new line (GPT-like behavior)
        if (isStreamingRef.current) {
          return; // Don't prevent default, allows new line
        }
        e.preventDefault();
        handleSubmit(e);
      }
    } else if (e.key === "Escape") {
      e.preventDefault();
      if (showMetadataDropdown) {
        setShowMetadataDropdown(false);
      } else if (showFilesDropdown) {
        setShowFilesDropdown(false);
      } else if (showDatajoltDropdown) {
        setShowDatajoltDropdown(false);
      } else if (showContextTypeDropdown) {
        setShowContextTypeDropdown(false);
      }
    } else if (showContextTypeDropdown) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedContextTypeIndex(prev => 
          prev < 2 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedContextTypeIndex(prev => prev > 0 ? prev - 1 : 0);
      }
    } else if (showFilesDropdown) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedFileIndex(prev => 
          prev < fileItems.length - 1 ? prev + 1 : prev
        );
        // Ensure the highlighted item is visible by scrolling if needed
        setTimeout(() => {
          const highlightedElement = document.querySelector('.file-item.highlighted');
          if (highlightedElement && filesDropdownRef.current) {
            const dropdownRect = filesDropdownRef.current.getBoundingClientRect();
            const elementRect = highlightedElement.getBoundingClientRect();
            
            if (elementRect.bottom > dropdownRect.bottom) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else if (elementRect.top < dropdownRect.top) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }, 0);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedFileIndex(prev => prev > 0 ? prev - 1 : 0);
        // Ensure the highlighted item is visible by scrolling if needed
        setTimeout(() => {
          const highlightedElement = document.querySelector('.file-item.highlighted');
          if (highlightedElement && filesDropdownRef.current) {
            const dropdownRect = filesDropdownRef.current.getBoundingClientRect();
            const elementRect = highlightedElement.getBoundingClientRect();
            
            if (elementRect.top < dropdownRect.top) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else if (elementRect.bottom > dropdownRect.bottom) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
          }
        }, 0);
      }
    } else if (showMetadataDropdown) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedIndex(prev => 
          prev < metadataItems.length - 1 ? prev + 1 : prev
        );
        // Ensure the highlighted item is visible by scrolling if needed
        setTimeout(() => {
          const highlightedElement = document.querySelector('.metadata-item.highlighted');
          if (highlightedElement && metadataDropdownRef.current) {
            const dropdownRect = metadataDropdownRef.current.getBoundingClientRect();
            const elementRect = highlightedElement.getBoundingClientRect();
            
            if (elementRect.bottom > dropdownRect.bottom) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else if (elementRect.top < dropdownRect.top) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }, 0);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedIndex(prev => prev > 0 ? prev - 1 : 0);
        // Ensure the highlighted item is visible by scrolling if needed
        setTimeout(() => {
          const highlightedElement = document.querySelector('.metadata-item.highlighted');
          if (highlightedElement && metadataDropdownRef.current) {
            const dropdownRect = metadataDropdownRef.current.getBoundingClientRect();
            const elementRect = highlightedElement.getBoundingClientRect();
            
            if (elementRect.top < dropdownRect.top) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else if (elementRect.bottom > dropdownRect.bottom) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
          }
        }, 0);
      }
    } else if (showDatajoltDropdown) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedDatajoltIndex(prev => 
          prev < datajoltObjects.length - 1 ? prev + 1 : prev
        );
        // Ensure the highlighted item is visible by scrolling if needed
        setTimeout(() => {
          const highlightedElement = document.querySelector('.datajolt-item.highlighted');
          if (highlightedElement && datajoltDropdownRef.current) {
            const dropdownRect = datajoltDropdownRef.current.getBoundingClientRect();
            const elementRect = highlightedElement.getBoundingClientRect();
            
            if (elementRect.bottom > dropdownRect.bottom) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else if (elementRect.top < dropdownRect.top) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }, 0);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedDatajoltIndex(prev => prev > 0 ? prev - 1 : 0);
        // Ensure the highlighted item is visible by scrolling if needed
        setTimeout(() => {
          const highlightedElement = document.querySelector('.datajolt-item.highlighted');
          if (highlightedElement && datajoltDropdownRef.current) {
            const dropdownRect = datajoltDropdownRef.current.getBoundingClientRect();
            const elementRect = highlightedElement.getBoundingClientRect();
            
            if (elementRect.top < dropdownRect.top) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else if (elementRect.bottom > dropdownRect.bottom) {
              highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
          }
        }, 0);
      }
    }
  };

  // Add a global event listener for the Escape key
  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape" && showMetadataDropdown) {
        setShowMetadataDropdown(false);
      }
    };
    
    document.addEventListener("keydown", handleEscapeKey);
    
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [showMetadataDropdown]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputMessage(value);
    
    // Auto adjust height based on content
    e.target.style.height = "auto";
    e.target.style.height = `${e.target.scrollHeight}px`;
    setInputHeight(e.target.scrollHeight);
    
    // Check if @ was just typed
    const cursorPos = e.target.selectionStart;
    const textBeforeCursor = value.substring(0, cursorPos);
    
    if (textBeforeCursor.endsWith('@')) {
      setCursorPosition(cursorPos);
      setMetadataSearchTerm('');
      setFileSearchTerm('');
      setShowContextTypeDropdown(true);
      setSelectedContextType(null);
    } else if (showMetadataDropdown && selectedContextType === 'metadata') {
      // If metadata dropdown is open, check if we're still in an @ mention context
      const atPos = textBeforeCursor.lastIndexOf('@');
      if (atPos >= 0) {
        const searchTerm = textBeforeCursor.substring(atPos + 1);
        setMetadataSearchTerm(searchTerm);
        fetchMetadataItems(searchTerm);
      } else {
        // If no @ found before cursor, close the dropdown
        setShowMetadataDropdown(false);
        setSelectedContextType(null);
      }
    } else if (showFilesDropdown && selectedContextType === 'files') {
      // If files dropdown is open, check if we're still in an @ mention context
      const atPos = textBeforeCursor.lastIndexOf('@');
      if (atPos >= 0) {
        const searchTerm = textBeforeCursor.substring(atPos + 1);
        setFileSearchTerm(searchTerm);
        fetchFileItems(searchTerm);
      } else {
        // If no @ found before cursor, close the dropdown
        setShowFilesDropdown(false);
        setSelectedContextType(null);
      }
    } else if (showDatajoltDropdown && selectedContextType === 'datajolt') {
      // If datajolt dropdown is open, check if we're still in an @ mention context
      const atPos = textBeforeCursor.lastIndexOf('@');
      if (atPos >= 0) {
        const searchTerm = textBeforeCursor.substring(atPos + 1);
        setDatajoltSearchTerm(searchTerm);
        fetchDatajoltObjects(searchTerm);
      } else {
        // If no @ found before cursor, close the dropdown
        setShowDatajoltDropdown(false);
        setSelectedContextType(null);
      }
    } else if (showContextTypeDropdown) {
      // If context type dropdown is open, check if we're still in an @ mention context
      const atPos = textBeforeCursor.lastIndexOf('@');
      if (atPos < 0) {
        // If no @ found before cursor, close the dropdown
        setShowContextTypeDropdown(false);
        setSelectedContextType(null);
      }
    }
    
    // Check if any selected tables have been removed from the input
    if (selectedTables.length > 0) {
      setSelectedTables(prevSelectedTables => {
        return prevSelectedTables.filter(table => {
          // Check if the full table name (schema.table) is still in the input
          return value.includes(table.name);
        });
      });
    }
    
    // Check if any selected files have been removed from the input
    if (selectedFiles.length > 0) {
      setSelectedFiles(prevSelectedFiles => {
        return prevSelectedFiles.filter(file => {
          // Always keep the active tab
          if (file.isActive && file.name === props.activeTab) {
            return true;
          }
          
          // For non-active files, check if they're still in the input
          return value.includes(`@file:${file.displayName}`);
        });
      });
    }
  };

  const handleSuggestedQuestionClick = async (questionText) => {
    const trimmedQuestionText = questionText.trim();
    if (trimmedQuestionText === "") {
      return;
    }
    
    // Call submitMessage directly without touching inputMessage state
    await submitMessage(trimmedQuestionText);
  };

  const newChat = () => {
    // Cancel any ongoing streaming before starting new chat
    stopStreaming();
    
    // Additional explicit margin reset after stopping streaming
    setTimeout(() => {
      if (messageListRef.current) {
        const allMessages = messageListRef.current.querySelectorAll('.gpt-message, .user-message');
        allMessages.forEach(msg => {
          msg.style.marginBottom = '16px';
        });
      }
    }, 0);
    
    isStreamingRef.current = false;        // Stop processing streaming updates
    streamingTextRef.current = '';         // Clear accumulated text
    
    const greetingMessage = {
      text: `Hi ${props.userName || ''}, how can I help you today? 🚀`,
      sender: "gpt",
      isTyping: false,
    };
    localStorage.removeItem('chatMessages'); // Clear stored messages
    localStorage.removeItem('conversation_id'); // Clear conversation ID
    setMessages([greetingMessage]);
    setInputMessage("");
    setShowHistory(false);
    setExcludeActiveTab(false); // Reset excludeActiveTab flag
  };

  const fetchConversations = async (page = 1, loadMore = false) => {
    try {
      if (!loadMore) {
        setLoadingHistory(true);
      } else {
        setLoadingMore(true);
      }
      
      const response = await axios.get(`${config.url.AI_URL}/api/ai/conversations?page=${page}&limit=10`);

      if (loadMore) {
        // Append new conversations to existing ones
        setConversations(prev => [...prev, ...response.data.conversations]);
      } else {
        // Replace conversations
        setConversations(response.data.conversations);
      }
      
      // Update pagination state
      setCurrentPage(response.data.pagination.current_page);
      setHasMoreConversations(response.data.pagination.has_more);
      setTotalConversations(response.data.pagination.total_count);
    } catch (error) {
      console.error("Error fetching conversations:", error);
      toast.error("Failed to load conversation history");
    } finally {
      setLoadingHistory(false);
      setLoadingMore(false);
    }
  };

  const loadMoreConversations = async () => {
    if (!loadingMore && hasMoreConversations) {
      await fetchConversations(currentPage + 1, true);
    }
  };

  const loadConversation = async (conversationId) => {
    try {
      setLoadingConversationId(conversationId);
      const response = await axios.post(
        `${config.url.AI_URL}/api/ai/retrieve_conversation`,
        {
          conversation_id: conversationId,
        }
      );
      
      // Hide history first
      setShowHistory(false);
      
      // Set messages
      const messages = response.data.messages || response.data;
      setMessages(messages);
      localStorage.setItem('conversation_id', conversationId);
      
      // Check if any message has completed execution plans
      setTimeout(() => {
        const hasCompletedExecution = messages.some(msg => 
          msg.tasks && msg.tasks.every(task => 
            task.status === 'completed' || task.status === 'error'
          )
        );
        if (hasCompletedExecution) {
          setShowExecutionComplete(true);
          // Follow same sequence as live streaming
          thinkingTimeoutRef.current = setTimeout(() => {
            setShowExecutionComplete(false);
            setShowThinking(true);
            // Then clear thinking state to show final result
            thinkingClearTimeoutRef.current = setTimeout(() => {
              setShowThinking(false);
            }, 500);
          }, 1000);
        }
      }, 100);
      
      // Wait for next render cycle to complete
      setTimeout(() => {
        // Conversation loaded
        
        // Give rendering of code blocks and complex formatting more time 
        // before hiding the spinner
        setTimeout(() => {
          setLoadingConversationId(null);
        }, 200);
      }, 100);
      
    } catch (error) {
      console.error("Error loading conversation:", error);
      toast.error("Failed to load conversation");
      setLoadingConversationId(null);
    }
  };

  const handleDeleteClick = (e, conversationId) => {
    e.stopPropagation(); // Prevent triggering the conversation load
    setConversationToDelete(conversationId);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      setIsDeletingConversation(true);
      const deleteUrl = `${config.url.AI_URL}/api/ai/delete_conversation`;

      await axios.post(deleteUrl, {
        conversation_id: conversationToDelete
      });

      // Remove the conversation from the list
      setConversations(
        conversations.filter((conv) => conv.id !== conversationToDelete)
      );
      setShowDeleteModal(false);
      toast.success("Conversation deleted successfully");
    } catch (error) {
      console.error("Error deleting conversation:", error);
      toast.error("Failed to delete conversation");
    } finally {
      setIsDeletingConversation(false);
    }
  };

  const formatTimestamp = (timestamp) => {
    // Explicitly parse the timestamp as UTC, then convert to local time
    return moment.utc(timestamp).local();
  };

  const handleRefreshContext = async (contextType) => {
    try {
      console.log(`Setting ${contextType} to loading...`);
      setRefreshingContext(prev => {
        const newState = { ...prev, [contextType]: true };
        console.log('New refreshing state:', newState);
        return newState;
      });
      
      const response = await axios.post(`${config.url.AI_URL}/api/ai/refresh_context`, {
        type: contextType,
        branch: props.branch
      });
      toast.success(`Successfully refreshed ${contextType} context`);
    } catch (error) {
      console.error(`Error refreshing ${contextType} context:`, error);
      toast.error(`Failed to refresh ${contextType} context`);
    } finally {
      console.log(`Setting ${contextType} back to not loading`);
      setRefreshingContext(prev => {
        const newState = { ...prev, [contextType]: false };
        console.log('Final refreshing state:', newState);
        return newState;
      });
    }
  };

  useEffect(() => {
    // Close dropdowns when clicking outside
    const handleClickOutside = (event) => {
      if (metadataDropdownRef.current && !metadataDropdownRef.current.contains(event.target)) {
        setShowMetadataDropdown(false);
      }
      if (filesDropdownRef.current && !filesDropdownRef.current.contains(event.target)) {
        setShowFilesDropdown(false);
      }
      if (contextTypeDropdownRef.current && !contextTypeDropdownRef.current.contains(event.target)) {
        setShowContextTypeDropdown(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const fetchMetadataItems = (searchTerm) => {
    setIsLoadingMetadata(true);
    
    try {
      // Use props.dwh_structure instead of API call
      if (!props.dwh_structure) {
        console.log("No dwh_structure available in props");
        setMetadataItems([]);
        setIsLoadingMetadata(false);
        return;
      }
      
      console.log("DWH Structure:", props.dwh_structure);
      let filteredItems = [];
      
      // Process the nested structure: schema -> tables -> columns
      if (typeof props.dwh_structure === 'object' && props.dwh_structure !== null) {
        // Iterate through schemas
        Object.entries(props.dwh_structure).forEach(([schemaName, tables]) => {
          if (typeof tables === 'object' && tables !== null) {
            // Iterate through tables in this schema
            Object.entries(tables).forEach(([tableName, columns]) => {
              const fullName = `${schemaName}.${tableName}`;
              
              // Check if this table matches the search term
              if (!searchTerm || 
                  fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  tableName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  schemaName.toLowerCase().includes(searchTerm.toLowerCase())) {
                
                filteredItems.push({
                  name: fullName,
                  displayName: tableName,
                  type: 'table',
                  schema: schemaName,
                  columns: Array.isArray(columns) ? columns : []
                });
              }
            });
          }
        });
      }
      
      console.log("Filtered metadata items:", filteredItems);
      setMetadataItems(filteredItems);
    } catch (error) {
      console.error("Error processing metadata:", error);
      setMetadataItems([]);
    } finally {
      setIsLoadingMetadata(false);
    }
  };
  
  const handleMetadataItemSelect = (item) => {
    // Get the current cursor position and text before it
    const cursorPos = inputRef.current.selectionStart;
    const textBeforeCursor = inputMessage.substring(0, cursorPos);
    
    // Find the position of the last @ symbol before cursor
    const lastAtPos = textBeforeCursor.lastIndexOf('@');
    
    if (lastAtPos >= 0) {
      // Create new text by replacing the @searchterm with @tablename
      const textBeforeAt = inputMessage.substring(0, lastAtPos);
      const textAfterCursor = inputMessage.substring(cursorPos);
      
      // Set the new input message with the table name inserted
      setInputMessage(`${textBeforeAt}@${item.name} ${textAfterCursor}`);
      
      // Add the selected table to the list if not already there
      if (!selectedTables.some(table => table.name === item.name)) {
        setSelectedTables([...selectedTables, item]);
      }
      
      // Close the dropdown
      setShowMetadataDropdown(false);
      
      // Focus back on the input and set cursor position after the inserted table name
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          const newCursorPos = textBeforeAt.length + item.name.length + 2; // +2 for @ and space
          inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
        }
      }, 0);
    }
  };
  
  const handleMetadataSearchChange = (e) => {
    const searchTerm = e.target.value;
    setMetadataSearchTerm(searchTerm);
    fetchMetadataItems(searchTerm);
  };

  const fetchFileItems = (searchTerm) => {
    setIsLoadingFiles(true);
    
    try {
      // Use props.files to get the list of open files
      if (!props.files) {
        console.log("No files available in props");
        setFileItems([]);
        setIsLoadingFiles(false);
        return;
      }
      
      let filteredItems = [];
      
      // Process the files object
      Object.entries(props.files).forEach(([name, content]) => {
        // Skip files that start with '+' (they are special tabs)
        if (!name.startsWith('+')) {
          // Check if this file matches the search term
          if (!searchTerm || name.toLowerCase().includes(searchTerm.toLowerCase())) {
            filteredItems.push({
              name: name,
              displayName: name.split('/').pop(), // Get just the filename
              type: 'file',
              isActive: name === props.activeTab
            });
          }
        }
      });
      
      // Add the active tab if it's not already in the list
      if (props.activeTab && !props.activeTab.startsWith('+') && 
          !filteredItems.some(item => item.name === props.activeTab)) {
        if (!searchTerm || props.activeTab.toLowerCase().includes(searchTerm.toLowerCase())) {
          filteredItems.push({
            name: props.activeTab,
            displayName: props.activeTab.split('/').pop(),
            type: 'file',
            isActive: true
          });
        }
      }
      
      console.log("Filtered file items:", filteredItems);
      setFileItems(filteredItems);
    } catch (error) {
      console.error("Error processing files:", error);
      setFileItems([]);
    } finally {
      setIsLoadingFiles(false);
    }
  };
  
  const handleFileItemSelect = (item) => {
    // Get the current cursor position and text before it
    const cursorPos = inputRef.current.selectionStart;
    const textBeforeCursor = inputMessage.substring(0, cursorPos);
    
    // Find the position of the last @ symbol before cursor
    const lastAtPos = textBeforeCursor.lastIndexOf('@');
    
    if (lastAtPos >= 0) {
      // Create new text by replacing the @searchterm with @filename
      const textBeforeAt = inputMessage.substring(0, lastAtPos);
      const textAfterCursor = inputMessage.substring(cursorPos);
      
      // Set the new input message with just the filename (not the full path)
      setInputMessage(`${textBeforeAt}@file:${item.displayName} ${textAfterCursor}`);
      
      // Add the selected file to the list if not already there
      if (!selectedFiles.some(file => file.name === item.name)) {
        console.log('Adding new file to context:', item.name);
        console.log('Current selectedFiles:', selectedFiles);
        
        // Create a new array with all existing files
        let newSelectedFiles = [...selectedFiles];
        
        // Add the new file
        newSelectedFiles.push({
          ...item,
          isActive: item.name === props.activeTab
        });
        
        console.log('New selectedFiles:', newSelectedFiles);
        setSelectedFiles(newSelectedFiles);
      }
      
      // Close the dropdown
      setShowFilesDropdown(false);
      
      // Focus back on the input and set cursor position after the inserted file name
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          const newCursorPos = textBeforeAt.length + item.displayName.length + 6; // +6 for "@file:" and space
          inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
        }
      }, 0);
    }
  };
  
  const handleFileSearchChange = (e) => {
    const searchTerm = e.target.value;
    setFileSearchTerm(searchTerm);
    fetchFileItems(searchTerm);
  };

  // Load datajolt objects once on component mount
  const loadDatajoltObjects = async () => {
    try {
      const response = await axios.get(`${config.url.WEBAPP}/api/datajolt/datajolt-objects`);
      if (response.data && Array.isArray(response.data)) {
        setAllDatajoltObjects(response.data);
      }
    } catch (error) {
      console.error("Error loading datajolt objects:", error);
      setAllDatajoltObjects([]);
    }
  };

  // Filter datajolt objects locally (no API call)
  const filterDatajoltObjects = (searchTerm) => {
    setIsLoadingDatajolt(true);
    
    let filteredItems = [];
    
    // Filter from cached objects based on search term
    if (allDatajoltObjects && Array.isArray(allDatajoltObjects)) {
      filteredItems = allDatajoltObjects.filter(item => {
        if (!searchTerm) return true;
        return item.alias.toLowerCase().includes(searchTerm.toLowerCase()) ||
               item.type.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }
    
    setDatajoltObjects(filteredItems);
    setHighlightedDatajoltIndex(0);
    setIsLoadingDatajolt(false);
  };

  // Legacy function name for backward compatibility
  const fetchDatajoltObjects = (searchTerm) => {
    filterDatajoltObjects(searchTerm);
  };

  const handleDatajoltObjectSelect = (item) => {
    // Get the current cursor position and text before it
    const cursorPos = inputRef.current.selectionStart;
    const textBeforeCursor = inputMessage.substring(0, cursorPos);
    
    // Find the position of the last @ symbol before cursor
    const lastAtPos = textBeforeCursor.lastIndexOf('@');
    let textBeforeAt = '';
    
    if (lastAtPos >= 0) {
      // Create new text by replacing the @searchterm with @datajolt:alias
      textBeforeAt = inputMessage.substring(0, lastAtPos);
      const textAfterCursor = inputMessage.substring(cursorPos);
      
      // Set the new input message with the datajolt object
      setInputMessage(`${textBeforeAt}@${item.type.toLowerCase()}:${item.alias} ${textAfterCursor}`);
      
      // Add the selected object to the list if not already there
      if (!selectedDatajoltObjects.some(obj => obj.alias === item.alias && obj.type === item.type)) {
        setSelectedDatajoltObjects([...selectedDatajoltObjects, item]);
      }
    }
    
    // Close the dropdown
    setShowDatajoltDropdown(false);
    
    // Focus back on the input and set cursor position after the inserted object name
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        const newCursorPos = textBeforeAt.length + item.type.length + item.alias.length + 3; // +3 for "@", ":", and space
        inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
      }
    }, 0);
  };

  const handleContextTypeSelect = (type) => {
    setSelectedContextType(type);
    setShowContextTypeDropdown(false);
    
    if (type === 'metadata') {
      setShowMetadataDropdown(true);
      fetchMetadataItems('');
    } else if (type === 'files') {
      setShowFilesDropdown(true);
      fetchFileItems('');
    } else if (type === 'datajolt') {
      setShowDatajoltDropdown(true);
      setIsLoadingDatajolt(true); // Set loading immediately
      fetchDatajoltObjects('');
    } else if (type === 'rules') {
      // Handle cursor rules context type
      // For now, just insert a placeholder
      const cursorPos = inputRef.current.selectionStart;
      const textBeforeCursor = inputMessage.substring(0, cursorPos);
      const lastAtPos = textBeforeCursor.lastIndexOf('@');
      
      if (lastAtPos >= 0) {
        const textBeforeAt = inputMessage.substring(0, lastAtPos);
        const textAfterCursor = inputMessage.substring(cursorPos);
        setInputMessage(`${textBeforeAt}@rule:cursor ${textAfterCursor}`);
        
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
            const newCursorPos = textBeforeAt.length + 12; // +12 for "@rule:cursor"
            inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
          }
        }, 0);
      }
    }
  };

  // Reset highlighted index when metadata items change
  useEffect(() => {
    setHighlightedIndex(0);
  }, [metadataItems]);

  // Reset highlighted index when dropdown opens
  useEffect(() => {
    if (showMetadataDropdown) {
      setHighlightedIndex(0);
    }
  }, [showMetadataDropdown]);

  // Reset highlighted file index when file items change
  useEffect(() => {
    setHighlightedFileIndex(0);
  }, [fileItems]);

  // Reset highlighted file index when dropdown opens
  useEffect(() => {
    if (showFilesDropdown) {
      setHighlightedFileIndex(0);
    }
  }, [showFilesDropdown]);

  // Cleanup streaming timeout on unmount
  useEffect(() => {
    return () => {
      clearTimeout(streamingUpdateTimeoutRef.current);
    };
  }, []);

  // Modify the useEffect for active tab changes to remove old active tabs
  useEffect(() => {
    if (props.activeTab && !props.activeTab.startsWith('+')) {
      // Check if this file is already in selectedFiles
      const isAlreadySelected = selectedFiles.some(file => file.name === props.activeTab);
      
      // Create a new array without any previous active tabs
      const filesWithoutPreviousActive = selectedFiles.filter(file => !file.isActive);
      
      if (!isAlreadySelected) {
        // Add the new active tab
        const newFile = {
          name: props.activeTab,
          displayName: props.activeTab.split('/').pop(),
          type: 'file',
          isActive: true
        };
        
        setSelectedFiles([...filesWithoutPreviousActive, newFile]);
      } else {
        // Just update the isActive flag for the current active tab
        setSelectedFiles(prev => prev.map(file => ({
          ...file,
          isActive: file.name === props.activeTab
        })));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeTab]);

  // Add this useEffect to load the conversation when the component mounts
  useEffect(() => {
    const loadInitialConversation = async () => {
      const conversationId = localStorage.getItem('conversation_id');
      if (conversationId) {
        try {
          setLoadingInitialConversation(true);
          const response = await axios.post(
            `${config.url.AI_URL}/api/ai/retrieve_conversation`,
            {
              conversation_id: conversationId,
            }
          );
          
          const messages = response.data.messages || response.data;
          if (response.data && messages.length > 0) {
            setMessages(messages);
            
            // Check if any message has completed execution plans
            setTimeout(() => {
              const hasCompletedExecution = messages.some(msg => 
                msg.tasks && msg.tasks.every(task => 
                  task.status === 'completed' || task.status === 'error'
                )
              );
              if (hasCompletedExecution) {
                setShowExecutionComplete(true);
                // Follow same sequence as live streaming
                thinkingTimeoutRef.current = setTimeout(() => {
                  setShowExecutionComplete(false);
                  setShowThinking(true);
                  // Then clear thinking state to show final result
                  thinkingClearTimeoutRef.current = setTimeout(() => {
                    setShowThinking(false);
                  }, 500);
                }, 1000);
              }
            }, 100);
            
            // Wait for rendering
            setTimeout(() => {
              // Initial conversation display
              
              // Wait extra time for rendering code blocks
              setTimeout(() => {
                setLoadingInitialConversation(false);
              }, 200);
            }, 100);
          } else {
            setLoadingInitialConversation(false);
          }
        } catch (error) {
          console.error("Error loading initial conversation:", error);
          localStorage.removeItem('conversation_id');
          setLoadingInitialConversation(false);
        }
      } else {
        setLoadingInitialConversation(false);
      }
    };

    loadInitialConversation();
  }, []);

  return (
    <>
      <section
        className="schedule-sidebar-content"
        style={{
          height: "100%",
          background: props.isDarkMode ? "#1e1e1e" : "#fff",
          display: "flex",
          flexDirection: "column",
          border: props.isDarkMode ? "1.2px solid #3c3c3c" : "1.2px solid #dfe0eb",
        }}
      >
        <div className="header-container" style={{ padding: 0 }}>
          <h2 className="heading-schedule-model m-0">
            <small
              style={{
                fontWeight: 500,
                fontSize: "12px",
                border: 0,
                borderRadius: 0,
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px",
                padding: "16px 15px",
                height: "auto",
                boxShadow: "none",
                color: props.isDarkMode ? "#ffffff" : "#448593",
                borderBottom: props.isDarkMode ? "1.2px solid #3c3c3c" : "1.2px solid #dfe0eb"
              }}
            >
              <ChevronsRight
                color={props.isDarkMode ? "#ffffff" : "#438593"}
                role="button"
                onClick={props.onHideSidebar}
                size={18}
              />              
              Robin
              <div className="ms-auto d-flex gap-2">
                <Tooltip
                  title={
                    <div style={{ textAlign: "center", padding: 4 }}>
                      <QRCodeSVG
                        value="https://wa.me/12282208600"
                        size={160}
                        bgColor="#448593"
                        fgColor="#ffffff"
                      />
                      <div style={{ fontSize: 11, marginTop: 4 }}>Scan to chat on WhatsApp</div>
                    </div>
                  }
                  slotProps={{
                    arrow: { sx: { color: "#448593" } },
                    tooltip: { sx: { backgroundColor: "#448593", maxWidth: 200 } }
                  }}
                >
                  <Smartphone
                    color={props.isDarkMode ? "#ffffff" : "#438593"}
                    role="button"
                    size={16}
                  />
                </Tooltip>
                <Tooltip
                  title="Chat History"
                  slotProps={{
                    arrow: {
                      sx: {
                        color: "#448593"
                      }
                    },
                    tooltip: {
                      sx: {
                        backgroundColor: "#448593",
                      }
                    }
                  }}
                >
                  <Clock
                    color={props.isDarkMode ? "#ffffff" : "#438593"}
                    role="button"
                    onClick={() => {
                      setCurrentPage(1);
                      setHasMoreConversations(false);
                      setTotalConversations(0);
                      fetchConversations();
                      setShowHistory(true);
                    }}
                    size={16}
                  />
                </Tooltip>
                <Tooltip
                  title="New Chat"
                  slotProps={{
                    arrow: {
                      sx: {
                        color: "#448593"
                      }
                    },
                    tooltip: {
                      sx: {
                        backgroundColor: "#448593",
                      }
                    }
                  }}
                >
                  <Plus
                    color={props.isDarkMode ? "#ffffff" : "#438593"}
                    role="button"
                    onClick={newChat}
                    size={16}
                  />
                </Tooltip>
              </div>
            </small>
          </h2>
        </div>

        {showHistory ? (
          <>
            <div
              className="conversation-history"
              style={{ flex: 1, overflowY: "auto" }}
            >
              {loadingHistory ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "100%" }}
                >
                  <DatajoltSpinner />
                </div>
              ) : (
                <div className="list-group">
                  {conversations.length === 0 ? (
                    <div className="text-center p-4">
                      <p className="text-muted mb-3">Let's have our first chat!</p>
                      <Button
                        variant="outlined" 
                        size="small"
                        onClick={newChat}
                        sx={{
                          padding: '8px 16px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          border: '1.5px solid #448593',
                          color: '#448593',
                          fontWeight: '500',
                          backgroundColor: 'white',
                          gap: "0.5rem"
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = 'translateY(-1px)';
                          e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                          e.currentTarget.style.backgroundColor = 'white';
                        }}
                      >
                        <Plus size={16} />
                        Start New Chat
                      </Button>
                    </div>
                  ) : (<><br/>
                    {conversations.map((conv) => (
                      <button
                        key={conv.id}
                        className={`list-group-item list-group-item-action ${
                          loadingConversationId === conv.id ? "loading" : ""
                        }`}
                        onClick={() => loadConversation(conv.id)}
                        style={{ fontSize: "11px" }}
                      >
                        <div className="d-flex w-100 justify-content-between align-items-center">
                          <div className="flex-grow-1">
                            <span className="mb-1">{conv.title}</span>
                            <div className="text-muted">
                              {formatTimestamp(conv.last_message_at).fromNow()}
                            </div>
                            <span className="text-muted d-block">
                              Started: {formatTimestamp(conv.started_at).format("MMM D, YYYY")}
                            </span>
                          </div>
                          {loadingConversationId === conv.id ? (
                            <span
                              className="spinner-border spinner-border-sm text-secondary"
                              role="status"
                              aria-hidden="true"
                              style={{ padding: "4px" }}
                            />
                          ) : (
                            <button
                              className="btn btn-link text-danger delete-button"
                              onClick={(e) => handleDeleteClick(e, conv.id)}
                              style={{ padding: "4px" }}
                            >
                              <Trash2 size={14} />
                            </button>
                          )}
                        </div>
                      </button>
                    ))}</>
                  )}
                  {hasMoreConversations && (
                    <div className="text-center p-3">
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={loadMoreConversations}
                        disabled={loadingMore}
                        sx={{
                          padding: '6px 16px',
                          fontSize: '11px',
                          borderColor: '#448593',
                          color: '#448593',
                          '&:hover': {
                            borderColor: '#448593',
                            backgroundColor: 'rgba(68, 133, 147, 0.04)'
                          }
                        }}
                      >
                        {loadingMore ? (
                          <>
                            <CircularProgress size={14} sx={{ mr: 1, color: '#448593' }} />
                            Loading...
                          </>
                        ) : (
                          `Load More (${totalConversations - conversations.length} remaining)`
                        )}
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div
              ref={messageListRef}
              className="message-list"
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "15px",
                position: "relative", // Added for absolute positioning of spinner
              }}
            >
              {(loadingInitialConversation || loadingConversationId) && (
                <div
                  className="loading-overlay"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: props.isDarkMode ? "#1e1e1e" : "#fff",
                    zIndex: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <DatajoltSpinner />
                </div>
              )}
              
              {/* Always render messages, they'll be hidden behind the spinner */}
              {messages.map((message, index) => (
                <div
                  key={index}
                  className={message.sender === "user" ? "user-message" : `gpt-message${message.tasks ? " full-width-message" : ""}`}
                >
                  {message.isTyping ? (
                    <div className="typing-indicator">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  ) : (
                    <div className="message-content" style={{ width: '100%' }}>
                      {/* Render task list if present */}
                      {message.tasks && message.tasks.length > 0 && (
                        <div className="task-list execution-plan-container" style={{ 
                          marginBottom: '18px'
                        }}>
                          <div className="execution-plan-full-width" style={{
                            background: props.isDarkMode ? '#252526' : '#ffffff',
                            border: props.isDarkMode ? '1px solid #3c3c3c' : '1px solid #e1e8ed',
                            borderRadius: '8px',
                            padding: collapsedPlans[index] ? '10px 16px' : '16px',
                            boxShadow: props.isDarkMode ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.06)'
                          }}>
                            <div
                              onClick={() => message.hasResult ? setCollapsedPlans(prev => ({...prev, [index]: !prev[index]})) : null}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: collapsedPlans[index] ? '0' : '14px',
                                marginLeft: '-3px',
                                fontSize: '13px',
                                fontWeight: '600',
                                color: props.isDarkMode ? '#ffffff' : '#2952ac',
                                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                                cursor: message.hasResult ? 'pointer' : 'default',
                                padding: '0'
                              }}
                            >
                              <div style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '4px',
                                background: '#2952ac',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '8px'
                              }}>
                                <svg width="12" height="12" viewBox="30.245 12.831 36.745 74.338" xmlns="http://www.w3.org/2000/svg">
                                  <polygon points="66.99,45.015 55.259,45.04 63.866,12.831 30.245,55.731 41.977,55.707 33.368,87.169" fill="white" />
                                </svg>
                              </div>
                              Execution Plan
                              {/* Display execution duration */}
                              {message.execution_duration !== null && message.execution_duration !== undefined && (
                                <div style={{
                                  marginLeft: '8px',
                                  fontSize: '10px',
                                  color: props.isDarkMode ? '#858585' : '#6b7280',
                                  fontFamily: 'monospace',
                                  background: props.isDarkMode ? '#3c3c3c' : '#f3f4f6',
                                  padding: '2px 6px',
                                  borderRadius: '3px',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}>
                                  ⏱️ {message.execution_duration}s
                                </div>
                              )}
                              {!message.hasResult && (
                                <div style={{
                                  marginLeft: '8px',
                                  width: '12px',
                                  height: '12px',
                                  border: '1.5px solid #e5e7eb',
                                  borderTop: '1.5px solid #2952ac',
                                  borderRadius: '50%',
                                  animation: 'spin 1s linear infinite'
                                }} />
                              )}
                              {message.hasResult && (
                                <div style={{
                                  marginLeft: 'auto',
                                  fontSize: '11px',
                                  color: props.isDarkMode ? '#858585' : '#6b7280',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}>
                                  {collapsedPlans[index] ? (
                                    <>
                                      ▶
                                      {(() => {
                                        const successCount = message.tasks.filter(t => t.status === 'completed').length;
                                        const failedCount = message.tasks.filter(t => t.status === 'error').length;
                                        const skippedCount = message.tasks.filter(t => t.status === 'skipped').length;
                                        if (successCount > 0 || failedCount > 0 || skippedCount > 0) {
                                          const parts = [];
                                          if (successCount > 0) parts.push(`${successCount} success`);
                                          if (failedCount > 0) parts.push(`${failedCount} failed`);
                                          if (skippedCount > 0) parts.push(`${skippedCount} skipped`);
                                          return ` ${parts.join(' | ')}`;
                                        }
                                        return '';
                                      })()}
                                    </>
                                  ) : '▼'}
                                </div>
                              )}
                            </div>
                            
                            {!collapsedPlans[index] && message.tasks.map((task, taskIndex) => {
                              const isCompleted = task.status === 'completed';
                              const isInProgress = task.status === 'in_progress';
                              const isError = task.status === 'error';
                              const isPending = task.status === 'pending';
                              const isSkipped = task.status === 'skipped';
                              
                              return (
                                <div
                                  key={task.id}
                                  className="task-item"
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    padding: '8px 12px',
                                    marginBottom: taskIndex === message.tasks.length - 1 ? '0' : '6px',
                                    background: props.isDarkMode
                                      ? (isCompleted ? '#1a2e1a' : isError ? '#2e1a1a' : isInProgress ? '#1a2236' : isSkipped ? '#2d2d2d' : '#252526')
                                      : (isCompleted ? '#f0fdf4' : isError ? '#fef2f2' : isInProgress ? '#eff6ff' : isSkipped ? '#f8f9fa' : '#f8fafc'),
                                    borderRadius: '6px',
                                    border: `1px solid ${props.isDarkMode
                                      ? (isCompleted ? '#2d4a2d' : isError ? '#4a2d2d' : isInProgress ? '#2d3a4a' : isSkipped ? '#3c3c3c' : '#3c3c3c')
                                      : (isCompleted ? '#d1fae5' : isError ? '#fecaca' : isInProgress ? '#dbeafe' : isSkipped ? '#dee2e6' : '#e2e8f0')}`,
                                    position: 'relative',
                                    overflow: 'hidden',
                                    transition: 'all 0.3s ease',
                                    animation: isInProgress ? 'pulse-glow 2s infinite' : 'none',
                                    transform: 'scale(1)',
                                    opacity: isCompleted ? '0.85' : isSkipped ? '0.6' : '1'
                                  }}
                                >
                                  {/* Animated progress bar */}
                                  {isInProgress && (
                                    <div style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      height: '100%',
                                      width: '100%',
                                      background: 'linear-gradient(90deg, transparent 0%, rgba(59, 130, 246, 0.08) 50%, transparent 100%)',
                                      animation: 'shimmer 2s infinite'
                                    }} />
                                  )}
                                  
                                  <div style={{
                                    width: '18px',
                                    height: '18px',
                                    borderRadius: '50%',
                                    marginRight: '10px',
                                    marginTop: '1px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0,
                                    background: isCompleted ? '#22c55e' : 
                                               isError ? '#ef4444' :
                                               isInProgress ? '#2952ac' : 
                                               isSkipped ? '#6c757d' :
                                               '#9ca3af',
                                    transition: 'all 0.3s ease'
                                  }}>
                                    {isPending && (
                                      <Clock size={9} style={{ color: 'white' }} />
                                    )}
                                    {isInProgress && (
                                      <div style={{
                                        width: '8px',
                                        height: '8px',
                                        border: '1.5px solid rgba(255, 255, 255, 0.3)',
                                        borderTop: '1.5px solid white',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                      }} />
                                    )}
                                    {isCompleted && (
                                      <Check size={10} style={{ color: 'white' }} />
                                    )}
                                    {isError && (
                                      <span style={{ color: 'white', fontSize: '10px', fontWeight: 'bold' }}>!</span>
                                    )}
                                    {isSkipped && (
                                      <span style={{ color: 'white', fontSize: '8px', fontWeight: 'bold' }}>–</span>
                                    )}
                                  </div>
                                  
                                  <div style={{ flex: 1, zIndex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{
                                      fontSize: '12px',
                                      lineHeight: '1.4',
                                      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                                    }}>
                                      {(() => {
                                        const fullDescription = `${task.description}${task.message ? ` - ${task.message}` : ''}`;
                                        const separatorIndex = fullDescription.indexOf(' - ');
                                        
                                        if (separatorIndex !== -1) {
                                          const toolPart = fullDescription.substring(0, separatorIndex + 3); // Include " - "
                                          const feedbackPart = fullDescription.substring(separatorIndex + 3);

                                          return (
                                            <>
                                              <span style={{ fontWeight: '500', color: props.isDarkMode ? '#cccccc' : '#1f2937' }}>
                                                {toolPart}
                                              </span>
                                              <span style={{ fontStyle: 'italic', color: props.isDarkMode ? '#858585' : '#6b7280', fontWeight: 'normal' }}>
                                                {feedbackPart}
                                              </span>
                                            </>
                                          );
                                        } else {
                                          return (
                                            <span style={{ fontWeight: '500', color: props.isDarkMode ? '#cccccc' : '#1f2937' }}>
                                              {fullDescription}
                                            </span>
                                          );
                                        }
                                      })()}
                                    </div>
                                    {/* Timer display - now inline on the right */}
                                    {(task.duration !== null && task.duration !== undefined) && (
                                      <div style={{
                                        fontSize: '10px',
                                        color: props.isDarkMode ? '#858585' : '#6b7280',
                                        fontFamily: 'monospace',
                                        marginLeft: '8px',
                                        flexShrink: 0
                                      }}>
                                        ⏱️ {task.duration}s
                                      </div>
                                    )}
                                    {isInProgress && task.start_time && (
                                      <div style={{
                                        fontSize: '10px',
                                        color: props.isDarkMode ? '#cccccc' : '#3b82f6',
                                        fontFamily: 'monospace',
                                        marginLeft: '8px',
                                        flexShrink: 0
                                      }}>
                                        ⏱️ {(() => {
                                          try {
                                            // Use local start time to avoid network latency offset
                                            const taskKey = `${index}-${taskIndex}`;
                                            if (!taskLocalStartTimes.current[taskKey]) {
                                              taskLocalStartTimes.current[taskKey] = Date.now();
                                            }
                                            const startTime = taskLocalStartTimes.current[taskKey];
                                            const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
                                            return `${elapsedSeconds}s`;
                                          } catch (e) {
                                            return 'Running...';
                                          }
                                        })()}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      
                      
                      {/* Show thinking state */}
                      {showThinking && !message.text && (
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#6b7280',
                          marginBottom: '18px'
                        }}>
                          <span style={{ 
                            fontSize: '12px',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                            fontStyle: 'italic'
                          }}>
                            Thinking{'.'.repeat(thinkingDots)}
                          </span>
                        </div>
                      )}
                      
                      {/* Render message text for non-task messages OR when we have results */}
                      {/* Show text if: no tasks OR no tasks in array OR hasResult, AND we have text content (either message.text or active typingText) */}
                      {(!message.tasks || message.tasks.length === 0 || message.hasResult) && (message.text || (message.isTypingAnimation && typingText)) && (
                        <div style={{ marginTop: message.hasResult ? '16px' : '0' }}>
                          <span className={`message-text ${message.isTypingAnimation && !isStreamingComplete ? 'streaming-text' : ''}`}>
                            {(() => {
                              // Use typing text if typing animation is active, otherwise use full message text
                              const textToDisplay = message.isTypingAnimation && typingText ? typingText : message.text;
                              const isStreaming = message.isTypingAnimation;
                              return formatMessage(textToDisplay, index, isStreaming);
                            })()}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <SuggestedQuestions
              onQuestionClick={handleSuggestedQuestionClick}
              isVisible={!showHistory}
              messages={messages}
              isDarkMode={props.isDarkMode}
              mode={props.mode}
            />
            <Form
              onSubmit={handleSubmit}
              className="message-input-form mt-auto"
              style={{
                width: '100%',
                padding: '10px',
                borderTop: props.isDarkMode ? '1.2px solid #3c3c3c' : '1.2px solid #dfe0eb',
                backgroundColor: props.isDarkMode ? '#1e1e1e' : '#fff',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative'
              }}
            >
              {(props.activeTab || props.selectedText || selectedTables.length > 0 || selectedFiles.length > 0) && (
                <div 
                  className="context-info" 
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px',
                    padding: '0 2px',
                    width: '100%'
                  }}
                >
                  {props.selectedText && (
                    <span 
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '10px',
                        fontWeight: '500',
                        backgroundColor: '#e6f4ea',
                        color: '#137333',
                        border: '1px solid #ceead6',
                        maxWidth: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        lineHeight: '1.2'
                      }}
                    >
                      {(() => {
                        const lines = props.selectedText.split('\n');
                        // Remove empty lines at the beginning and end
                        let startIndex = 0;
                        let endIndex = lines.length - 1;
                        
                        while (startIndex <= endIndex && lines[startIndex].trim() === '') {
                          startIndex++;
                        }
                        
                        while (endIndex >= startIndex && lines[endIndex].trim() === '') {
                          endIndex--;
                        }
                        
                        const lineCount = Math.max(1, endIndex - startIndex + 1);
                        return `${lineCount} line${lineCount !== 1 ? 's' : ''} selected`;
                      })()}
                    </span>
                  )}
                  {selectedTables.length > 0 && (
                    selectedTables.map((table, idx) => (
                      <span 
                        key={idx}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          fontSize: '10px',
                          fontWeight: '500',
                          backgroundColor: '#fef7e0',
                          color: '#b06000',
                          border: '1px solid #feefc3',
                          maxWidth: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          gap: '4px',
                          lineHeight: '1.2'
                        }}
                      >
                        <Database size={10} style={{ flexShrink: 0 }} />
                        <span style={{ flexGrow: 1, maxWidth: 'calc(100% - 34px)' }}>
                          {table.displayName}
                        </span>
                        <span 
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedTables(prev => prev.filter((_, i) => i !== idx));
                            // Also remove from input text
                            setInputMessage(prev => prev.replace(`@${table.name} `, ''));
                          }}
                          style={{
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '14px',
                            height: '14px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(176, 96, 0, 0.1)',
                            marginLeft: '2px',
                            flexShrink: 0
                          }}
                        >
                          ×
                        </span>
                      </span>
                    ))
                  )}
                  {selectedFiles.length > 0 && (
                    selectedFiles.map((file, idx) => (
                      <span 
                        key={idx}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          fontSize: '10px',
                          fontWeight: '500',
                          backgroundColor: '#e8f0fe',
                          color: '#1a73e8',
                          border: '1px solid #d2e3fc',
                          maxWidth: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          gap: '4px',
                          lineHeight: '1.2'
                        }}
                      >
                        <FileText size={10} style={{ flexShrink: 0 }} />
                        <span style={{ flexGrow: 1, maxWidth: 'calc(100% - 34px)' }}>
                          {file.displayName}
                        </span>
                        <span 
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedFiles(prev => prev.filter((_, i) => i !== idx));
                            // Also remove from input text
                            setInputMessage(prev => prev.replace(`@file:${file.name} `, ''));
                          }}
                          style={{
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '14px',
                            height: '14px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(26, 115, 232, 0.1)',
                            marginLeft: '2px',
                            flexShrink: 0
                          }}
                        >
                          ×
                        </span>
                      </span>
                    ))
                  )}
                </div>
              )}
              <div className="d-flex align-items-center gap-2 w-100">
                <div className="position-relative flex-grow-1">
                  {/* Only render the overlay if there are @references */}                  
                  <Form.Control
                    as="textarea"
                    rows="2"
                    placeholder="Message me..."
                    value={inputMessage}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    className="datajolt-input"
                    ref={inputRef}
                    style={{
                      height: inputHeight,
                      minHeight: "50px",
                      maxHeight: "200px",
                      resize: "vertical",
                      overflowY: "auto",
                      width: '100%',
                      paddingRight: '40px',
                      padding: '6px 36px 6px 12px',
                      color: 'black',
                      backgroundColor: 'white !important',
                      fontSize: '11px',
                      lineHeight: '1.5',
                      fontFamily: 'inherit',
                      wordWrap: 'break-word',
                      whiteSpace: 'pre-wrap',
                      border: '1px solid #ced4da',
                      borderRadius: '0.25rem',
                      transition: 'none',
                      outline: 'none',
                      boxShadow: 'none'
                    }}
                  />
                  
                  {showContextTypeDropdown && (
                    <div 
                      ref={contextTypeDropdownRef}
                      className="context-type-dropdown"
                      style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: 0,
                        width: '100%',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        zIndex: 1000,
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        marginBottom: '5px'
                      }}
                    >
                      <div 
                        className={`p-2 border-top ${highlightedContextTypeIndex === 0 ? 'highlighted' : ''}`}
                        onClick={() => handleContextTypeSelect('datajolt')}
                        style={{ 
                          cursor: 'pointer',
                          backgroundColor: highlightedContextTypeIndex === 0 ? '#f0f7ff' : 'transparent',
                          borderLeft: highlightedContextTypeIndex === 0 ? '3px solid #438593' : '3px solid transparent'
                        }}
                        onMouseEnter={() => setHighlightedContextTypeIndex(0)}
                      >
                        <div className="fw-bold d-flex align-items-center gap-2">
                          <svg width="14" height="14" viewBox="30.245 12.831 36.745 74.338" fill="#FFEE15">
                            <polygon points="66.99,45.015 55.259,45.04 63.866,12.831 30.245,55.731 41.977,55.707 33.368,87.169"/>
                          </svg>
                          <span>Datajolt</span>
                        </div>
                      </div>
                      <div 
                        className={`p-2 border-top ${highlightedContextTypeIndex === 1 ? 'highlighted' : ''}`}
                        onClick={() => handleContextTypeSelect('files')}
                        style={{ 
                          cursor: 'pointer',
                          backgroundColor: highlightedContextTypeIndex === 1 ? '#f0f7ff' : 'transparent',
                          borderLeft: highlightedContextTypeIndex === 1 ? '3px solid #438593' : '3px solid transparent'
                        }}
                        onMouseEnter={() => setHighlightedContextTypeIndex(1)}
                      >
                        <div className="fw-bold d-flex align-items-center gap-2">
                          <FileText size={14} />
                          <span>Files</span>
                        </div>
                      </div>
                      <div 
                        className={`p-2 border-top ${highlightedContextTypeIndex === 2 ? 'highlighted' : ''}`}
                        onClick={() => handleContextTypeSelect('metadata')}
                        style={{ 
                          cursor: 'pointer',
                          backgroundColor: highlightedContextTypeIndex === 2 ? '#f0f7ff' : 'transparent',
                          borderLeft: highlightedContextTypeIndex === 2 ? '3px solid #438593' : '3px solid transparent'
                        }}
                        onMouseEnter={() => setHighlightedContextTypeIndex(2)}
                      >
                        <div className="fw-bold d-flex align-items-center gap-2">
                          <Database size={14} />
                          <span>Metadata</span>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {showFilesDropdown && selectedContextType === 'files' && (
                    <div 
                      ref={filesDropdownRef}
                      className="files-dropdown"
                      style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: 0,
                        width: '100%',
                        maxHeight: '200px',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        zIndex: 1000,
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        marginBottom: '5px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <div className="p-2" style={{
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        zIndex: 1,
                        borderBottom: '1px solid #eee'
                      }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search files..."
                          value={fileSearchTerm}
                          onChange={handleFileSearchChange}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div style={{ overflowY: 'auto', maxHeight: '160px' }}>
                        {isLoadingFiles ? (
                          <div className="text-center p-2">
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          </div>
                        ) : fileItems.length === 0 ? (
                          <div className="p-2 text-muted">No files found</div>
                        ) : (
                          <div>
                            {fileItems.map((item, index) => (
                              <div
                                key={index}
                                className={`p-2 border-top file-item ${highlightedFileIndex === index ? 'highlighted' : ''}`}
                                onClick={() => handleFileItemSelect(item)}
                                style={{ 
                                  cursor: 'pointer', 
                                  backgroundColor: highlightedFileIndex === index ? '#f0f7ff' : 'transparent',
                                  borderLeft: highlightedFileIndex === index ? '3px solid #438593' : '3px solid transparent'
                                }}
                                onMouseEnter={() => setHighlightedFileIndex(index)}
                              >
                                <div className="fw-bold d-flex align-items-center gap-2">
                                  <FileText size={12} />
                                  <span>{item.displayName}</span>
                                  {item.isActive && (
                                    <span className="badge bg-primary ms-1" style={{ fontSize: '8px' }}>Active</span>
                                  )}
                                </div>
                                <div className="text-muted small">{item.name}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {showMetadataDropdown && selectedContextType === 'metadata' && (
                    <div 
                      ref={metadataDropdownRef}
                      className="metadata-dropdown"
                      style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: 0,
                        width: '100%',
                        maxHeight: '200px',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        zIndex: 1000,
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        marginBottom: '5px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <div className="p-2" style={{
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        zIndex: 1,
                        borderBottom: '1px solid #eee'
                      }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search tables..."
                          value={metadataSearchTerm}
                          onChange={handleMetadataSearchChange}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div style={{ overflowY: 'auto', maxHeight: '160px' }}>
                        {isLoadingMetadata ? (
                          <div className="text-center p-2">
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          </div>
                        ) : metadataItems.length === 0 ? (
                          <div className="p-2 text-muted">No tables found</div>
                        ) : (
                          <div>
                            {metadataItems.map((item, index) => (
                              <div
                                key={index}
                                className={`p-2 border-top metadata-item ${highlightedIndex === index ? 'highlighted' : ''}`}
                                onClick={() => handleMetadataItemSelect(item)}
                                style={{ 
                                  cursor: 'pointer', 
                                  backgroundColor: highlightedIndex === index ? '#f0f7ff' : 'transparent',
                                  borderLeft: highlightedIndex === index ? '3px solid #438593' : '3px solid transparent'
                                }}
                                onMouseEnter={() => setHighlightedIndex(index)}
                              >
                                <div className="fw-bold">{item.displayName}</div>
                                <div className="text-muted small">{item.schema}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {showDatajoltDropdown && selectedContextType === 'datajolt' && (
                    <div 
                      ref={datajoltDropdownRef}
                      className="datajolt-dropdown"
                      style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: 0,
                        width: '100%',
                        maxHeight: '200px',
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        zIndex: 1000,
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        marginBottom: '5px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <div className="p-2" style={{
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        zIndex: 1,
                        borderBottom: '1px solid #eee'
                      }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search taps, pushes, DAGs..."
                          value={datajoltSearchTerm}
                          onChange={(e) => {
                            setDatajoltSearchTerm(e.target.value);
                            fetchDatajoltObjects(e.target.value);
                          }}
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                      <div style={{ overflowY: 'auto', maxHeight: '160px' }}>
                        {isLoadingDatajolt ? (
                          <div className="text-center p-3">
                            <div className="spinner-border spinner-border-sm" role="status" style={{ color: '#556ee6' }}>
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : datajoltObjects.length === 0 ? (
                          <div className="p-2 text-muted">No objects found</div>
                        ) : (
                          <div>
                            {datajoltObjects.map((item, index) => (
                              <div
                                key={index}
                                className={`p-2 border-top datajolt-item ${highlightedDatajoltIndex === index ? 'highlighted' : ''}`}
                                onClick={() => handleDatajoltObjectSelect(item)}
                                style={{ 
                                  cursor: 'pointer', 
                                  backgroundColor: highlightedDatajoltIndex === index ? '#f0f7ff' : 'transparent',
                                  borderLeft: highlightedDatajoltIndex === index ? '3px solid #438593' : '3px solid transparent'
                                }}
                                onMouseEnter={() => setHighlightedDatajoltIndex(index)}
                              >
                                <div className="fw-bold d-flex align-items-center gap-2">
                                  <div style={{
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '6px',
                                    background: item.type === 'Tap' ? 'rgba(85, 110, 230, 0.12)' : 
                                               item.type === 'DAG' ? 'rgba(85, 110, 230, 0.12)' : 
                                               item.type === 'Push' ? 'rgba(52, 120, 246, 0.15)' : 'rgba(200, 200, 200, 0.12)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: item.type === 'Tap' ? '0 2px 4px rgba(85, 110, 230, 0.15)' :
                                              item.type === 'DAG' ? '0 2px 4px rgba(85, 110, 230, 0.15)' :
                                              item.type === 'Push' ? '0 2px 4px rgba(52, 120, 246, 0.15)' : 'none'
                                  }}>
                                    {item.type === 'Tap' ? (
                                      <RefreshCw size={12} style={{ color: '#556ee6' }} />
                                    ) : item.type === 'DAG' ? (
                                      <Clock size={12} style={{ color: '#556ee6' }} />
                                    ) : item.type === 'Push' ? (
                                      <UploadCloud size={12} style={{ color: '#3478f6' }} />
                                    ) : (
                                      <Database size={12} style={{ color: '#666' }} />
                                    )}
                                  </div>
                                  <span>{item.alias}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  <Button
                    variant="text"
                    className={isStreamingRef.current ? "pulse-ring" : ""}
                    onClick={(e) => {
                      // Prevent action if disabled state but allow cursor to show
                      if (!isStreamingRef.current && inputMessage.trim() === "") {
                        e.preventDefault();
                        return;
                      }
                      if (isStreamingRef.current) {
                        stopStreaming(e);
                      } else {
                        handleSubmit(e);
                      }
                    }}
                    sx={{
                      position: "absolute",
                      color: (!isStreamingRef.current && inputMessage.trim() === "") ? 'rgba(67, 133, 147, 0.5)' : '#438593',
                      padding: '0 8px',
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      right: '5px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      height: '28px',
                      width: '32px',
                      zIndex: 5,
                      minWidth: "0",
                      cursor: 'pointer',
                      opacity: (!isStreamingRef.current && inputMessage.trim() === "") ? 0.6 : 1,
                    }}
                  >
                    {isStreamingRef.current ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="6" y="6" width="12" height="12" rx="2"></rect>
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="22" y1="2" x2="11" y2="13"></line>
                        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                      </svg>
                    )}
                  </Button>
                </div>
                              </div>
            </Form>
          </>
        )}
      </section>

      {/* Delete Confirmation Modal */}
      <DeleteChatModal
        onAction={handleDeleteConfirm}
        onHide={() => setShowDeleteModal(false)}
        isShown={showDeleteModal}
        isDeletingConversation={isDeletingConversation}
      />
    </>
  );
});

export default ChatBot;